@if(!showCanvasUI){
<div>
  @if (userDepartment !== 'MARKETING') {
  <div>
    <div class="overview-header overview-animate d-flex justify-content-between align-items-center mt-3 px-5">
      <div class="overview-left">
        <h1>Overview</h1>
        <p>
          See your latest overview of your <strong>{{ overviewSubhead }}</strong> Leads
        </p>
      </div>
    </div>
    <div class="border-btm"></div>
  </div>
  <div class="overview-right position-absolute">
    <div class="kanban-view-btn" role="button" tabindex="0" (click)="goToKanban()">
      <img src="/assets/leads/kanban.png" width="22" height="22" alt="Kanban view" />
      <span>Go to Kanban</span>
    </div>

    <div class="fx-date-range-wrapper d-flex align-items-center gap-2">
      <!-- Date Range Picker -->
      <div class="fx-date-range-container position-relative">
        <input class="fx-date-range tag" type="text" matInput ngxDaterangepickerMd [locale]="locale" [drops]="'down'"
          [opens]="'left'" [showCustomRangeLabel]="false" [alwaysShowCalendars]="true"
          [keepCalendarOpeningWithRange]="true" [showCancel]="true" [startKey]="'startDate'" [endKey]="'endDate'"
          [autoApply]="true" autocomplete="off" name="daterange" [(ngModel)]="selectedDateRange"
          (datesUpdated)="onDateSelected($event)" (hide)="onDatepickerHide()" placeholder="Search by date range"
          readonly />
        <i class="far fa-calendar-alt calendar-icon"></i>
        @if(isFilteredView) {
        <button class="clear-btn" (click)="clearDateFilter()" title="Clear date filter">
          <i class="fas fa-times"></i>
        </button>
        }
      </div>
    </div>

    <img class="bubble-img position-absolute" src="../../../assets/leads/bubbles.png" alt="bubbles" />
  </div>
  }
  <!-- CARDS ROW -->
  @if (userDepartment !== 'MARKETING') {
  <div class="cards-floating">
    <!-- CARD 1 -->
    <div class="stat-card animate-card">
      <div class="card-inner">
        <div class="card-head d-flex align-items-center">
          <div class="icon-box dark">
            <img src="../../../assets/leads/recent-lead-icon.png" alt="recent-lead-icon" />
          </div>
          <span class="card-title ml-2">Total Leads / Assigned</span>
        </div>

        @if (isStatsLoading) {

        <!-- SHIMMER -->
        <div class="card-shimmer pt-4 d-flex justify-content-between align-items-center">
          <div>
            <div class="shimmer-count shimmer"></div>
            <div class="shimmer-chart shimmer mt-3"></div>
          </div>
          <div>
            <div class="shimmer-text shimmer mt-3"></div>
          </div>
        </div>

        } @else {
        <div class="card-content d-flex justify-content-between align-items-center pt-4">
          <h2 class="mb-0">
            {{ this.totalsLeadsCounts }}<span style="color:#8a94a6; font-weight:400;">/</span>{{
            this.totalAssignedLeadsCount ?? '-' }}
          </h2>
          <div class="mini-chart chart-blue">
            <img src="../../../assets/leads/recent-lead-graph.png" alt="recent-lead" />
          </div>
        </div>

        <p class="growth-text">
          @if (totalLeadsTrend?.type === 'neutral') {
          <span class="neutral">No change from last week</span>
          } @else {
          <span class="value" [class.green]="totalLeadsTrend?.type === 'positive'"
            [class.red]="totalLeadsTrend?.type === 'negative'">
            {{ totalLeadsTrend?.value }}
          </span>
          {{ totalLeadsTrend?.text }}
          }
        </p>
        }
      </div>
    </div>

    <!-- CARD 2 -->
    <div class="stat-card animate-card">
      <div class="card-inner">
        <div class="card-head d-flex align-items-center">
          <div class="icon-box dark">
            <img src="../../../assets/leads/progress-lead-icon.png" alt="progress-lead-icon" />
          </div>
          <span class="card-title ml-2">In progress Leads</span>
        </div>

        @if (isStatsLoading) {

        <!-- SHIMMER -->
        <div class="card-shimmer pt-4 d-flex justify-content-between align-items-center">
          <div>
            <div class="shimmer-count shimmer"></div>
            <div class="shimmer-chart shimmer mt-3"></div>
          </div>
          <div>
            <div class="shimmer-text shimmer mt-3"></div>
          </div>
        </div>

        } @else {
        <div class="card-content d-flex justify-content-between align-items-center pt-4">
          <h2>{{ this.totalInProgressCount }}</h2>
          <div class="mini-chart chart-blue">
            <img class="progress-graph" src="../../../assets/leads/progress-lead-graph.png" alt="progress-lead" />
          </div>
        </div>

        <p class="growth-text">
          @if (progressLeadTrend?.type === 'neutral') {
          <span class="neutral">No change from last week</span>
          } @else {
          <span class="value" [class.green]="progressLeadTrend?.type === 'positive'"
            [class.red]="progressLeadTrend?.type === 'negative'">
            {{ progressLeadTrend?.value }}
          </span>
          {{ progressLeadTrend?.text }}
          }
        </p>
        }
      </div>
    </div>

    <!-- CARD 3 -->
    <div class="stat-card animate-card">
      <div class="card-inner">
        <div class="card-head d-flex align-items-center">
          <div class="icon-box dark">
            <img src="../../../assets/leads/converted-lead-icon.png" alt="converted-lead-icon" />
          </div>
          <span class="card-title ml-2">Converted Leads</span>
        </div>

        @if (isStatsLoading) {

        <!-- SHIMMER -->
        <div class="card-shimmer pt-4 d-flex justify-content-between align-items-center">
          <div>
            <div class="shimmer-count shimmer"></div>
            <div class="shimmer-chart shimmer mt-3"></div>
          </div>
          <div>
            <div class="shimmer-text shimmer mt-3"></div>
          </div>
        </div>

        } @else {
        <div class="card-content d-flex justify-content-between align-items-center pt-4">
          <h2>{{ this.totalConvertedLeadsCount }}</h2>
          <div class="mini-chart chart-blue">
            <img src="../../../assets/leads/converted-lead-graph.png" alt="converted-lead" />
          </div>
        </div>

        <p class="growth-text">
          @if (convertedLeadTrend?.type === 'neutral') {
          <span class="neutral">No change from last week</span>
          } @else {
          <span class="value" [class.green]="convertedLeadTrend?.type === 'positive'"
            [class.red]="convertedLeadTrend?.type === 'negative'">
            {{ convertedLeadTrend?.value }}
          </span>
          {{ convertedLeadTrend?.text }}
          }
        </p>
        }
      </div>
    </div>

    <!-- CARD 4 -->
    <div class="stat-card animate-card">
      <div class="card-inner">
        <div class="card-head d-flex align-items-center">
          <div class="icon-box dark">
            <img src="../../../assets/leads/lost-lead-icon.png" alt="lost-lead-icon" />
          </div>
          <span class="card-title ml-2">Lost Leads</span>
        </div>

        @if (isStatsLoading) {

        <!-- SHIMMER -->
        <div class="card-shimmer pt-4 d-flex justify-content-between align-items-center">
          <div>
            <div class="shimmer-count shimmer"></div>
            <div class="shimmer-chart shimmer mt-3"></div>
          </div>
          <div>
            <div class="shimmer-text shimmer mt-3"></div>
          </div>
        </div>

        } @else {

        <div class="card-content d-flex justify-content-between align-items-center pt-4">
          <h2>{{ this.totalLostLeadsCount }}</h2>
          <div class="mini-chart chart-blue">
            <img src="../../../assets/leads/lost-lead-graph.png" alt="lost-lead" />
          </div>
        </div>

        <p class="growth-text">
          @if (lostLeadTrend?.type === 'neutral') {
          <span class="neutral">No change from last week</span>
          } @else {
          <span class="value" [class.green]="lostLeadTrend?.type === 'positive'"
            [class.red]="lostLeadTrend?.type === 'negative'">
            {{ lostLeadTrend?.value }}
          </span>
          {{ lostLeadTrend?.text }}
          }
        </p>
        }
      </div>
    </div>
  </div>
  }

  <!-- ADMIN LEADS DASHBOARD -->
  @if (userDepartment !== 'MARKETING') {
  <!-- FOLLOW-UP REMINDERS SECTION -->
  <div class="follow-up-reminders-container" style="margin-top: 10rem;">
    <div class="follow-up-reminders-header">
      <div class="follow-up-reminders-title-group">
        <div class="follow-up-reminders-icon-wrapper">
          <i class="fas fa-bell"></i>
        </div>
        <h3 class="follow-up-reminders-title">
          Follow-up Reminders
        </h3>
      </div>

      <div class="reminders-tabs-wrapper d-flex align-items-center flex-wrap" style="gap: 12px;">
        <!-- Sales User Filter Dropdown -->
        <div class="dropdown reminder-user-filter-dd position-relative" [class.show]="reminderUserDropdownOpen">
          <button type="button"
            class="btn dropdown-toggle reminder-user-filter-btn d-flex align-items-center justify-content-between"
            (click)="toggleReminderUserDropdown($event)">
            <div class="d-flex align-items-center text-truncate" style="gap: 7px;">
              @if (selectedReminderUserObj?.profileImg) {
              <img [src]="selectedReminderUserObj.profileImg" class="rounded-circle" width="20" height="20"
                style="object-fit: cover; flex-shrink: 0;" (error)="selectedReminderUserObj.profileImg = null" />
              } @else if (selectedReminderUser) {
              <div class="reminder-user-avatar-initial">{{ selectedReminderUser.charAt(0).toUpperCase() }}</div>
              } @else {
              <i class="fas fa-users" style="color: #6366f1; font-size: 12px;"></i>
              }
              <span class="reminder-user-btn-label text-truncate">
                {{ selectedReminderUser || 'All Users' }}
              </span>
            </div>
            <i class="fas fa-chevron-down ml-2" style="font-size: 10px; color: #94a3b8;"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end shadow-sm reminder-user-filter-menu"
            [class.show]="reminderUserDropdownOpen">
            <a class="dropdown-item d-flex align-items-center justify-content-between"
              [class.active]="!selectedReminderUser" (click)="selectReminderUser('', $event)">
              <div class="d-flex align-items-center" style="gap: 8px;">
                <div class="reminder-user-all-icon">
                  <i class="fas fa-users"></i>
                </div>
                <span class="reminder-user-name">All Users</span>
              </div>
              @if (!selectedReminderUser) {
              <i class="fas fa-check text-primary" style="font-size: 11px;"></i>
              }
            </a>
            <div class="dropdown-divider my-1"></div>
            @for (user of salesUsers; track user._id || user.id || user.userName || $index) {
            <a class="dropdown-item d-flex align-items-center justify-content-between"
              [class.active]="selectedReminderUser === (user.userName || user.username || user.name)"
              (click)="selectReminderUser(user.userName || user.username || user.name, $event, user)">
              <div class="d-flex align-items-center" style="gap: 8px;">
                @if (user.profileImg) {
                <img [src]="user.profileImg" class="rounded-circle" width="20" height="20"
                  style="object-fit: cover; flex-shrink: 0;" (error)="user.profileImg = null" />
                } @else {
                <div class="reminder-user-avatar-initial">{{ (user.userName || user.username || user.name ||
                  'U').charAt(0).toUpperCase() }}</div>
                }
                <span class="reminder-user-name text-truncate" style="max-width: 140px;">{{ user.userName ||
                  user.username || user.name }}</span>
              </div>
              @if (selectedReminderUser === (user.userName || user.username || user.name)) {
              <i class="fas fa-check text-primary" style="font-size: 11px;"></i>
              }
            </a>
            }
          </div>
        </div>

        <!-- Status Filter Tabs -->
        <ul class="reminders-tabs">
          @for (tab of remindersTabs; track tab) {
          <li [class.active]="activeReminderTab === tab" (click)="onReminderTabChange(tab)">
            {{ tab }}
            <span class="tab-count-badge">{{ getReminderCount(tab) }}</span>
          </li>
          }
        </ul>
      </div>
    </div>

    <!-- Content Area -->
    <div class="reminders-content-area">
      <!-- Loading State -->
      @if (isRemindersLoading && (!displayedReminders || displayedReminders.length === 0)) {
      <div class="reminders-loading-state">
        <div class="spinner-border text-primary mb-3" role="status" style="width: 2rem; height: 2rem;">
          <span class="sr-only">Loading reminders...</span>
        </div>
        <p class="text-muted mb-0" style="font-size: 13.5px; font-weight: 500;">
          Loading {{ activeReminderTab.toLowerCase() }} reminders...
        </p>
      </div>
      }
      <!-- Populated State -->
      @else if (displayedReminders && displayedReminders.length > 0) {
      <div class="reminders-grid">
        @for (item of displayedReminders; track item._id || item.id || $index) {
        <div class="reminder-card">
          <!-- Card Header: Lead Name + Status Badge -->
          <div class="reminder-card-header">
            <div>
              <div class="d-flex align-items-center" style="gap: 8px;">
                @if (item.companyProfileImg) {
                <img [src]="item.companyProfileImg" class="rounded-circle" width="22" height="22"
                  style="object-fit: cover; flex-shrink: 0;" />
                }
                <h4 class="reminder-lead-name" title="View lead details" (click)="openLeadFromReminder(item)">
                  {{ getReminderLeadName(item) }}
                </h4>
              </div>
              @if (getReminderLeadPhone(item)) {
              <span class="text-muted d-block" style="font-size: 12px; margin-top: 2px;">
                <i class="fas fa-phone-alt mr-1" style="font-size: 10px; color: #94a3b8;"></i>{{
                getReminderLeadPhone(item) }}
              </span>
              }
            </div>

            <span class="reminder-badge"
              [style.background]="getReminderStatusBadge(item.status || activeReminderTab).bg"
              [style.color]="getReminderStatusBadge(item.status || activeReminderTab).color"
              [style.border]="'1px solid ' + getReminderStatusBadge(item.status || activeReminderTab).border">
              <i [class]="getReminderStatusBadge(item.status || activeReminderTab).icon" style="font-size: 10.5px;"></i>
              {{ item.status || activeReminderTab }}
            </span>
          </div>

          <!-- Note / Target Status Meta Content -->
          @if (item.note || item.notes || item.description || item.targetStatus || item.projectTab || item.source) {
          <div class="reminder-note-box" style="border-left-color: #6366f1;">
            @if (item.note || item.notes || item.description) {
            <div class="mb-1">{{ item.note || item.notes || item.description }}</div>
            }
            @if (item.targetStatus) {
            <div>
              Target Status: <strong>{{ item.targetStatus }}</strong>
            </div>
            }
            @if (item.projectTab || item.source) {
            <div [class.mt-1]="item.targetStatus" style="font-size: 12px; color: #64748b;">
              Source : <strong style="color: #334155;">{{ item.projectTab || item.source }}</strong>
            </div>
            }
          </div>
          }

          <!-- Creator Info -->
          @if (item.createdBy?.userName) {
          <div class="d-flex align-items-center mb-2" style="gap: 6px; font-size: 11.5px; color: #64748b;">
            @if (item.createdBy?.profileImg) {
            <img [src]="item.createdBy.profileImg" class="rounded-circle" width="16" height="16"
              style="object-fit: cover;" (error)="item.createdBy.profileImg = null" />
            } @else {
            <i class="fas fa-user-circle" style="font-size: 12px; color: #94a3b8;"></i>
            }
            <span>Created by <strong>{{ item.createdBy.userName }}</strong></span>
          </div>
          }

          <!-- Card Footer: Due Date + Time + Project Pill + Action -->
          <div class="reminder-card-footer">
            <div class="reminder-due-time">
              <div class="d-flex align-items-center" style="gap: 5px;">
                <i class="far fa-calendar-alt"></i>
                <span>{{ (item.dueAt || item.reminderDate || item.date || item.createdAt) | date:'dd MMM yyyy' }}</span>
              </div>
              @if (hasReminderTime(item.dueAt || item.reminderDate || item.date)) {
              <div class="d-flex align-items-center reminder-time-text"
                style="gap: 5px; font-size: 11.5px; color: #64748b; margin-top: 2px;">
                <i class="far fa-clock" style="font-size: 10.5px; color: #6366f1;"></i>
                <span>{{ (item.dueAt || item.reminderDate || item.date || item.createdAt) | date:'hh:mm a' }}</span>
              </div>
              }
            </div>

            <div class="d-flex align-items-center" style="gap: 8px;">
              @if (item.project || getLeadProjectBadge(item)) {
              <span class="project-pill-badge" [ngClass]="{
                'badge-iic-lab': (item.project || getLeadProjectBadge(item)) === 'IIC-LAB',
                'badge-iic': (item.project || getLeadProjectBadge(item)) === 'IIC',
                'badge-v-retail': (item.project || getLeadProjectBadge(item)) === 'V-RETAIL',
                'badge-v-estate': (item.project || getLeadProjectBadge(item)) === 'V-ESTATE',
                'badge-outbound': (item.project || getLeadProjectBadge(item)) === 'OUTBOUND'
              }">{{ item.project || getLeadProjectBadge(item) }}</span>
              }

              @if ((item.status || activeReminderTab) !== 'Completed') {
              <button type="button" class="reminder-done-btn" [class.btn-ready]="hasUpcomingTaskScheduled(item)"
                [class.btn-needs-task]="!hasUpcomingTaskScheduled(item)"
                [disabled]="updatingReminderId === (item._id || item.id)" (click)="markReminderAsDone(item, $event)"
                [title]="hasUpcomingTaskScheduled(item) ? 'Mark reminder as completed' : 'Set reminder for next task to complete'">
                @if (updatingReminderId === (item._id || item.id)) {
                <span class="spinner-border spinner-border-sm mr-1" role="status"
                  style="width: 11px; height: 11px; border-width: 1.5px;"></span>
                } @else {
                <i class="fas fa-check mr-1"></i>
                }
                Mark as Done
              </button>
              } @else {
              <span class="reminder-completed-pill">
                <i class="fas fa-check-circle mr-1"></i> Done
              </span>
              }
            </div>
          </div>
        </div>
        }
      </div>

      <!-- Load More Spinner -->
      @if (remindersLoadingMore) {
      <div class="text-center py-3">
        <span class="spinner-border spinner-border-sm text-primary"></span>
        <span class="ml-2 text-muted" style="font-size: 12px;">Loading more...</span>
      </div>
      }
      <!-- Load More Button -->
      @if (remindersHasMore[activeReminderTab] && !remindersLoadingMore && remindersData[activeReminderTab].length >=
      remindersLimit && !selectedReminderUser) {
      <div class="text-center mt-3">
        <button type="button" class="btn btn-sm btn-outline-primary px-3"
          (click)="fetchFollowUpReminders(activeReminderTab, true)"
          style="border-radius: 20px; font-size: 12px; font-weight: 600;">
          Load More
        </button>
      </div>
      }
      }
      <!-- Empty State (Only shown when not loading!) -->
      @else if (!isRemindersLoading) {
      <div class="reminders-empty-state">
        <i class="far fa-bell-slash"></i>
        <p>No {{ activeReminderTab.toLowerCase() }} follow-up reminders{{ selectedReminderUser ? ' for ' +
          selectedReminderUser : '' }}</p>
        <span>Reminders scheduled with follow-up tasks and dispositions will appear here.</span>
      </div>
      }
    </div>
  </div>

  <div class="graph-container d-flex align-items-stretch">
    <div class="chart-bg">
      <div class="chart-head d-flex align-items-center justify-content-between mb-2">
        <p class="mt-2 mb-2 d-flex align-items-center">
          <img class="mr-2" src="../../../assets/leads/leadsByScore.png" alt="" width="38px" />
          <span class="dashboard-chart-title">Territory Map</span>
        </p>
      </div>
      @if (isTerritoryLoading) {
      <div class="widget-skeleton territory-skeleton mt-3" aria-label="Loading territory map"></div>
      } @else {
      <div #chart class="chart-container mt-4"></div>
      }
    </div>

    <div class="donut-bg status-breakdown-card">
      <!-- HEADER -->
      <div class="chart-head d-flex align-items-center justify-content-between mb-2">
        <p class="mt-2 mb-2 d-flex align-items-center">
          <img class="mr-2" src="../../../assets/leads/leadsByScore.png" alt="" width="38px" />
          <span class="dashboard-chart-title">Status Breakdown</span>
        </p>
      </div>

      <!-- BODY CONTENT -->
      <div class="status-card-body">
        <!-- TOP SECTION: DONUT BOX & MINIMIZED METRICS -->
        <div class="status-top-row">
          <!-- LEFT BOX: CENTERED DONUT CHART -->
          <div class="status-donut-box">
            <div class="status-donut-wrapper">
              <div id="donutchart">
                <div class="status-donut-center">
                  <span class="status-donut-percent">{{ getOverallPercentage() }}</span>
                  <span class="status-donut-label">Complete</span>
                </div>

                @if (isDonutChartLoading) {
                <div class="widget-skeleton donut-skeleton" aria-label="Loading status breakdown"></div>
                } @else {
                <apx-chart [series]="donutchartOptions.series" [chart]="donutchartOptions.chart"
                  [labels]="donutchartOptions.labels" [responsive]="donutchartOptions.responsive"
                  [colors]="donutchartOptions.colors" [legend]="donutchartOptions.legend"
                  [dataLabels]="donutchartOptions.dataLabels" [plotOptions]="donutchartOptions.plotOptions"></apx-chart>
                }
              </div>
            </div>
          </div>

          <!-- RIGHT BOX: MINIMIZED METRIC CARDS -->
          <div class="status-metrics-grid">
            @if (isDonutChartLoading) {
            <div class="widget-skeleton radial-skeleton" aria-label="Loading status details"></div>
            } @else {
            <!-- CARD 1: TOTAL -->
            <div class="status-metric-card card-total">
              <div class="metric-card-left">
                <div class="metric-icon-badge badge-total">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="8"></circle>
                    <circle cx="12" cy="10" r="2.5"></circle>
                    <path d="M7.5 16.5c1-1.5 2.8-2.5 4.5-2.5s3.5 1 4.5 2.5"></path>
                    <circle cx="12" cy="3" r="1.2" fill="currentColor"></circle>
                    <circle cx="21" cy="12" r="1.2" fill="currentColor"></circle>
                    <circle cx="12" cy="21" r="1.2" fill="currentColor"></circle>
                    <circle cx="3" cy="12" r="1.2" fill="currentColor"></circle>
                  </svg>
                </div>
                <div class="metric-info">
                  <span class="metric-value">{{ totalsLeadsCounts || 0 }}</span>
                  <span class="metric-label">Total</span>
                </div>
              </div>
              <div class="metric-card-right">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round">
                  <line x1="6" y1="20" x2="6" y2="14"></line>
                  <line x1="12" y1="20" x2="12" y2="9"></line>
                  <line x1="18" y1="20" x2="18" y2="4"></line>
                </svg>
              </div>
            </div>

            <!-- CARD 2: IN PROGRESS -->
            <div class="status-metric-card card-inprogress">
              <div class="metric-card-left">
                <div class="metric-icon-badge badge-inprogress">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="8"></circle>
                    <circle cx="12" cy="10" r="2.5"></circle>
                    <path d="M7.5 16.5c1-1.5 2.8-2.5 4.5-2.5s3.5 1 4.5 2.5"></path>
                    <circle cx="12" cy="3" r="1.2" fill="currentColor"></circle>
                    <circle cx="21" cy="12" r="1.2" fill="currentColor"></circle>
                    <circle cx="12" cy="21" r="1.2" fill="currentColor"></circle>
                    <circle cx="3" cy="12" r="1.2" fill="currentColor"></circle>
                  </svg>
                </div>
                <div class="metric-info">
                  <span class="metric-value">{{ totalInProgressCount || 0 }}</span>
                  <span class="metric-label">In Progress</span>
                </div>
              </div>
              <div class="metric-card-right">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round">
                  <line x1="6" y1="20" x2="6" y2="14"></line>
                  <line x1="12" y1="20" x2="12" y2="9"></line>
                  <line x1="18" y1="20" x2="18" y2="4"></line>
                </svg>
              </div>
            </div>

            <!-- CARD 3: CONVERTED -->
            <div class="status-metric-card card-converted">
              <div class="metric-card-left">
                <div class="metric-icon-badge badge-converted">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="8"></circle>
                    <circle cx="12" cy="10" r="2.5"></circle>
                    <path d="M7.5 16.5c1-1.5 2.8-2.5 4.5-2.5s3.5 1 4.5 2.5"></path>
                    <circle cx="12" cy="3" r="1.2" fill="currentColor"></circle>
                    <circle cx="21" cy="12" r="1.2" fill="currentColor"></circle>
                    <circle cx="12" cy="21" r="1.2" fill="currentColor"></circle>
                    <circle cx="3" cy="12" r="1.2" fill="currentColor"></circle>
                  </svg>
                </div>
                <div class="metric-info">
                  <span class="metric-value">{{ totalConvertedLeadsCount || 0 }}</span>
                  <span class="metric-label">Converted</span>
                </div>
              </div>
              <div class="metric-card-right">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round">
                  <line x1="6" y1="20" x2="6" y2="14"></line>
                  <line x1="12" y1="20" x2="12" y2="9"></line>
                  <line x1="18" y1="20" x2="18" y2="4"></line>
                </svg>
              </div>
            </div>

            <!-- CARD 4: LOST -->
            <div class="status-metric-card card-lost">
              <div class="metric-card-left">
                <div class="metric-icon-badge badge-lost">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="8"></circle>
                    <circle cx="12" cy="10" r="2.5"></circle>
                    <path d="M7.5 16.5c1-1.5 2.8-2.5 4.5-2.5s3.5 1 4.5 2.5"></path>
                    <circle cx="12" cy="3" r="1.2" fill="currentColor"></circle>
                    <circle cx="21" cy="12" r="1.2" fill="currentColor"></circle>
                    <circle cx="12" cy="21" r="1.2" fill="currentColor"></circle>
                    <circle cx="3" cy="12" r="1.2" fill="currentColor"></circle>
                  </svg>
                </div>
                <div class="metric-info">
                  <span class="metric-value">{{ totalLostLeadsCount || 0 }}</span>
                  <span class="metric-label">Lost</span>
                </div>
              </div>
              <div class="metric-card-right">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round">
                  <line x1="6" y1="20" x2="6" y2="14"></line>
                  <line x1="12" y1="20" x2="12" y2="9"></line>
                  <line x1="18" y1="20" x2="18" y2="4"></line>
                </svg>
              </div>
            </div>

            <!-- CARD 5: CLOSING POOL -->
            <div class="status-metric-card card-closingpool clickable-card" (click)="goToKanbanClosingPool()">
              <div class="metric-card-left">
                <div class="metric-icon-badge badge-closingpool">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="8"></circle>
                    <circle cx="12" cy="10" r="2.5"></circle>
                    <path d="M7.5 16.5c1-1.5 2.8-2.5 4.5-2.5s3.5 1 4.5 2.5"></path>
                    <circle cx="12" cy="3" r="1.2" fill="currentColor"></circle>
                    <circle cx="21" cy="12" r="1.2" fill="currentColor"></circle>
                    <circle cx="12" cy="21" r="1.2" fill="currentColor"></circle>
                    <circle cx="3" cy="12" r="1.2" fill="currentColor"></circle>
                  </svg>
                </div>
                <div class="metric-info">
                  <span class="metric-value">{{ totalClosingPoolCount || 0 }}</span>
                  <span class="metric-label">Closing Pool</span>
                </div>
              </div>
              <div class="metric-card-right">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round">
                  <line x1="6" y1="20" x2="6" y2="14"></line>
                  <line x1="12" y1="20" x2="12" y2="9"></line>
                  <line x1="18" y1="20" x2="18" y2="4"></line>
                </svg>
              </div>
            </div>
            }
          </div>
        </div>

        <!-- BOTTOM LEGEND PILL IN BOTTOM SPACE -->
        <div class="status-legend-pill-bottom">
          <div class="status-legend-item">
            <span class="status-legend-dot dot-total"></span>
            <span>Total</span>
          </div>
          <div class="status-legend-item">
            <span class="status-legend-dot dot-inprogress"></span>
            <span>Inprogress</span>
          </div>
          <div class="status-legend-item">
            <span class="status-legend-dot dot-converted"></span>
            <span>Converted</span>
          </div>
          <div class="status-legend-item">
            <span class="status-legend-dot dot-lost"></span>
            <span>Lost</span>
          </div>
          <div class="status-legend-item clickable-legend" (click)="goToKanbanClosingPool()">
            <span class="status-legend-dot dot-closingpool"></span>
            <span>Closing Pool</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
  @if(project !== 'IIC-LAB'){
  <div class="leads-listing-banner" [class.marketing-banner]="userDepartment === 'MARKETING'">
    <div class="d-flex align-items-center justify-content-between table-header-flex-wrapper"
      [class.is-outbound-header]="project === 'OUTBOUND' || project === 'outbound'">
      <div class="d-flex align-items-center menu-content-inner"
        [class.is-outbound-inner]="project === 'OUTBOUND' || project === 'outbound'">
        <div class="leads-count">
          <p>
            Leads
            @if(selectedSection === 'Newsletter' || selectedType === 'Newsletter'){
            <small class="count-num ml-1">({{ this.newsLetterLength }})</small>
            } @else if(selectedSection === 'Career' || selectedType === 'Career'){
            <small class="count-num ml-1">({{ this.careerLength }})</small>
            } @else {
            <small class="count-num ml-1">({{ this.totalLeads }})</small>
            }
          </p>
        </div>

        <div class="search-box ml-3 position-relative">
          <input type="text" placeholder="Search Leads" [(ngModel)]="searchQuery" (input)="onSearchChange()" />
          <svg class="search-icon position-absolute" width="19" height="19" viewBox="0 0 19 19" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.3233 12.9048C15.5703 11.2971 16.158 9.27482 15.9668 7.24925C15.7757 5.22367 14.82 3.34701 13.2943 2.00104C11.7685 0.655069 9.78735 -0.0590965 7.75375 0.00383158C5.72015 0.0667597 3.7869 0.902055 2.34731 2.33978C0.906468 3.77851 0.068442 5.7125 0.00401015 7.74765C-0.0604217 9.78279 0.65359 11.7659 2.00054 13.2929C3.34749 14.8199 5.22601 15.7758 7.25329 15.9659C9.28056 16.1559 11.304 15.5658 12.9113 14.3158L12.9543 14.3608L17.1963 18.6038C17.2892 18.6967 17.3995 18.7704 17.5209 18.8207C17.6423 18.871 17.7724 18.8968 17.9038 18.8968C18.0352 18.8968 18.1653 18.871 18.2867 18.8207C18.4081 18.7704 18.5184 18.6967 18.6113 18.6038C18.7042 18.5109 18.7779 18.4006 18.8282 18.2792C18.8785 18.1578 18.9044 18.0277 18.9044 17.8963C18.9044 17.7649 18.8785 17.6348 18.8282 17.5134C18.7779 17.392 18.7042 17.2817 18.6113 17.1888L14.3683 12.9468L14.3233 12.9048ZM12.2473 3.75478C12.8119 4.31026 13.2609 4.97203 13.5685 5.70192C13.8761 6.43181 14.0361 7.21537 14.0393 8.0074C14.0425 8.79944 13.8889 9.58428 13.5873 10.3166C13.2857 11.049 12.8421 11.7144 12.282 12.2745C11.7219 12.8345 11.0565 13.2782 10.3242 13.5798C9.59181 13.8814 8.80697 14.035 8.01493 14.0318C7.2229 14.0286 6.43933 13.8686 5.70945 13.561C4.97956 13.2534 4.31779 12.8044 3.76231 12.2398C2.65223 11.1115 2.03297 9.59023 2.03941 8.0074C2.04586 6.42458 2.67749 4.90843 3.79672 3.78919C4.91596 2.66996 6.43211 2.03833 8.01493 2.03188C9.59775 2.02544 11.119 2.6447 12.2473 3.75478Z"
              fill="#999999" />
          </svg>
          @if(searchQuery){
          <img class="search-close" style="cursor: pointer" src="../../../assets/closeIcon.png" alt=""
            (click)="clearSearch()" />
          }
        </div>
        <div class="d-flex align-items-center position-relative header-action-btns">
          @if (canViewDeletedLeads) {
          <button class="btn btn-outline-danger ml-2 unqualified-btn" [class.active]="isDeletedFilter"
            (click)="toggleDeletedFilter()">
            Deleted Leads
          </button>
          }
          @if (isDeletedFilter) {
          <span class="cross-icon" (click)="resetDeletedFilter($event)">
            ✕
          </span>
          }
          @if (project !== 'ALL' && project !== 'all' && project !== 'V-RETAIL' && project !== 'v-retail' && project !==
          'V-ESTATE' && project !== 'v-estate') {
          <button type="button" class="gradient-btn ml-2 d-inline-flex align-items-center gap-1"
            (click)="openCreateOutboundLeadModal()">
            + Create Lead
          </button>
          }
        </div>
      </div>


      @if (userDepartment === 'MARKETING') {
      <div class="marketing-date-filter position-relative">
        <i class="far fa-calendar-alt calendar-icon-left"></i>
        <input class="date-filter-input fx-date-range" type="text" matInput ngxDaterangepickerMd [locale]="locale"
          [drops]="'down'" [opens]="'left'" [ranges]="ranges" [showCustomRangeLabel]="false"
          [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true" [showCancel]="true"
          [startKey]="'startDate'" [endKey]="'endDate'" [autoApply]="true" autocomplete="off" name="daterange"
          [(ngModel)]="selectedDateRange" (datesUpdated)="onDateSelected($event)" (hide)="onDatepickerHide()"
          placeholder="Select Date" readonly />

        @if(isFilteredView) {
        <button class="btn-clear-date-inside" (click)="clearDateFilter()" title="Clear date filter">
          <i class="fas fa-times"></i>
        </button>
        }
      </div>
      }
    </div>

    <div class=" table-banner mt-4">
      @if(isSpinnerLoader){
      <div class="loader-wrapper">
        <span class="loader"></span>
      </div>
      }
      <div class="demo-tracker-banner" [style.height]="bannerHeight" [style.maxHeight]="bannerHeight" infiniteScroll
        #infiniteScroller [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()"
        [scrollWindow]="false">
        @if (!isShimmerLoading){
        <table class="table leads-content" style="overflow-x: auto; width: 2180px">
          <thead>
            <tr>
              <th scope="col" class="sno-col">S.N0</th>
              <th scope="col" class="date-col">DATE</th>
              @if(project === 'ALL') {
              <th scope="col" class="project-col">PROJECT</th>
              }
              <th scope="col" class="name-col">NAME</th>
              @if (project === 'OUTBOUND') {
              <th scope="col" class="source-col">SOURCE</th>
              } @else {
              <th scope="col" class="source-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="All Sources" [(value)]="selectedType"
                      panelWidth="auto" panelClass="admin-table-dropdown" (selectionChange)="onTabChange($event.value)">
                      <mat-option value="ALL" title="All Sources">All Sources</mat-option>

                      @if (project === 'V-RETAIL') {
                      <mat-option value="Contact Us" title="Contact Us">Contact Us</mat-option>
                      <mat-option value="Book Demo" title="Book A Demo">Book A Demo</mat-option>
                      <mat-option value="User Onboard" title="Onboarding">Onboarding</mat-option>
                      <mat-option value="Lead Magnet Features" title="Lead Magnet Features">Lead Magnet
                        Features</mat-option>
                      <mat-option value="Lead Magnet Book Demo" title="Lead Magnet Book Demo">Lead Magnet Book
                        Demo</mat-option>
                      <mat-option value="Lead Magnet Pricing" title="Lead Magnet Pricing">Lead Magnet
                        Pricing</mat-option>
                      <mat-option value="Email" title="Email">Email</mat-option>
                      <mat-option value="Ads" title="Ads">Ads</mat-option>
                      } @else if (project === 'V-ESTATE' || project === 'IIC-LAB') {
                      <mat-option value="Contact Us" title="Contact Us">Contact Us</mat-option>
                      <mat-option value="Book Demo" title="Book A Demo">Book A Demo</mat-option>
                      <mat-option value="IVR" title="IVR">IVR</mat-option>
                      <mat-option value="Whatsapp" title="Whatsapp">Whatsapp</mat-option>
                      <mat-option value="Email" title="Email">Email</mat-option>
                      <mat-option value="Ads" title="Ads">Ads</mat-option>
                      } @else {
                      <mat-option value="Contact Us" title="Contact Us">Contact Us</mat-option>
                      <mat-option value="Book Demo" title="Book A Demo">Book A Demo</mat-option>
                      <mat-option value="User Onboard" title="Onboarding">Onboarding</mat-option>
                      <mat-option value="Lead Magnet Features" title="Lead Magnet Features">Lead Magnet
                        Features</mat-option>
                      <mat-option value="Lead Magnet Book Demo" title="Lead Magnet Book Demo">Lead Magnet Book
                        Demo</mat-option>
                      <mat-option value="Lead Magnet Pricing" title="Lead Magnet Pricing">Lead Magnet
                        Pricing</mat-option>
                      <mat-option value="IVR" title="IVR">IVR</mat-option>
                      <mat-option value="Newsletter" title="Newsletter">Newsletter</mat-option>
                      <mat-option value="Career" title="Career">Career</mat-option>
                      <mat-option value="Whatsapp" title="Whatsapp">Whatsapp</mat-option>
                      <mat-option value="Email" title="Email">Email</mat-option>
                      <mat-option value="Ads" title="Ads">Ads</mat-option>
                      <mat-option value="Outbound" title="Outbound">Outbound</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              }
              <th scope="col" class="user-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="All Users" [(value)]="selectedAssignedUser"
                      panelWidth="auto" panelClass="admin-table-dropdown"
                      (selectionChange)="onAssignedUserChange($event.value)"
                      (openedChange)="onAssigneeFilterOpened($event)">
                      <mat-option value="allUsers" title="All Users">All Users</mat-option>

                      @for (user of iicUsers; track user.id) {
                      <mat-option [value]="user.id" [title]="user.username">{{
                        user.username
                        }}</mat-option>
                      }

                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              <th scope="col" class="status-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="All Status" [(value)]="selectedOptionStatus"
                      panelWidth="auto" panelClass="admin-table-dropdown" (selectionChange)="onStatusChange()">
                      <mat-option value="" title="All Status">All Status</mat-option>
                      <mat-option value="Not started" title="Not started">Not started</mat-option>
                      <mat-option value="Contacted" title="Contacted">Contacted</mat-option>
                      <mat-option value="Meetings in Video call" title="Meetings in Video call">Meetings in Video
                        call</mat-option>
                      <mat-option value="Meetings in person" title="Meetings in person">Meetings in person</mat-option>
                      <mat-option value="Presentation" title="Presentation">Presentation</mat-option>
                      <mat-option value="Cost sheet" title="Cost sheet">Cost sheet</mat-option>
                      <mat-option value="Closing Pool" title="Closing Pool">Closing Pool</mat-option>
                      <mat-option value="Closed" title="Closed">Closed</mat-option>
                      <mat-option value="Lost" title="Lost">Lost</mat-option>
                      <mat-option value="unassigned" title="Unassigned">Unassigned</mat-option>
                      <mat-option value="Unqualified" title="Unqualified">Unqualified</mat-option>
                      <!-- <mat-option value="unqualified">Deleted Leads</mat-option> -->
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              <th scope="col" class="customer-value-col">CUSTOMER VALUE</th>

              @if (project === 'OUTBOUND') {
              <th scope="col" style="width: 90px; min-width: 90px; max-width: 90px;">CREATED BY</th>
              }

              @if((project === 'V-ESTATE' || project === 'IIC-LAB' || project === 'ALL') && (selectedType === 'IVR' ||
              selectedType === 'ALL')){
              <th scope="col" class="caller-no-col">CALLER NO</th>
              <th scope="col" class="caller-no-col">CALLER ID</th>

              <th scope="col" class="direction-col">DIRECTION</th>
              <th scope="col" class="duration-col">DURATION</th>
              }
              <th scope="col" class="designation-col">DESIGNATION</th>
              <th scope="col" class="email-col">EMAIL</th>
              <th scope="col" class="contact-no-col">CONTACT NO</th>
              @if(project === 'ALL' || project === 'IIC-LAB' || (project === 'V-ESTATE' && (selectedType === 'Contact
              Us' || selectedType ===
              'Book Demo' ||
              selectedType === 'whatsapp' || selectedType === 'Whatsapp' || selectedType === 'Email' ||
              selectedType === 'ALL'))){
              <th scope="col" class="utm-source-col">UTM SOURCE</th>
              <th scope="col" class="utm-medium-col">UTM MEDIUM</th>
              <th scope="col" class="utm-content-col">UTM CONTENT</th>
              <th scope="col" class="landing-page-col">LANDING PAGE</th>
              }





              @if (!isUnQualifiedFilter && (userDepartment !== 'MARKETING' || canAssignLeads)) {
              <th scope="col" class="option-col">OPTION</th>
              }
              @if (canDeleteLeads) {
              <th scope="col" class="action-col">ACTION</th>
              }

            </tr>
          </thead>
          <tbody>
            @for(lead of filteredLeads; track lead._id;let i=$index){

            <tr>
              <td>
                <p style="margin-right: 8px; font-weight: 600">{{ i + 1 }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                <p class="mb-0">
                  {{ lead?.createdAt | date : "dd-MM-yy" }}
                </p>
                @if (lead?.createdAt) {
                <div class="text-muted small" style="font-size: 11px; margin-top: 1px; font-weight: 400;">
                  ({{ lead?.createdAt | date : "hh:mm a" }})
                </div>
                }
              </td>
              @if(project === 'ALL') {
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                <span class="project-badge" [ngClass]="{
                  'badge-iic-lab': getLeadProjectBadge(lead) === 'IIC-LAB',
                  'badge-v-retail': getLeadProjectBadge(lead) === 'V-RETAIL',
                  'badge-v-estate': getLeadProjectBadge(lead) === 'V-ESTATE',
                  'badge-outbound': getLeadProjectBadge(lead) === 'OUTBOUND'
                }">{{ getLeadProjectBadge(lead) === 'ALL' ? '-' : getLeadProjectBadge(lead) }}</span>
              </td>
              }
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                <p class="name">{{ (lead.name && lead.name !== getAgentName(lead)) ? lead.name : "-" }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                <p>
                  {{ lead?.source ? lead?.source : "-" }}
                </p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                <p [innerHTML]="getAssignedToDisplay(lead, true)"></p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                <p [ngClass]="getStatusClass(lead?.status)" title="{{ lead?.status }}">
                  {{ lead?.status ? lead?.status : "-" }}
                </p>
                @if (lead?.deal) {
                <span class="deal-tag" [class.lost]="lead.deal.status === 'cancelled'"
                  [class.won]="lead.deal.status !== 'pipeline' && lead.deal.status !== 'cancelled'"
                  title="Deal in Finance: {{ lead.deal.name }} · {{ lead.deal.status }}">
                  {{ lead.deal.status === 'pipeline' ? 'Pipeline deal' : (lead.deal.status === 'cancelled' ? 'Deal lost'
                  : 'Deal won') }}
                </span>
                }
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                @if (lead?.customerValue || lead?.badge) {
                <span class="badge-pill {{ getBadgeClass(lead?.customerValue || lead?.badge) }}">
                  {{ lead.customerValue || lead.badge }}
                </span>
                } @else {
                <span class="customer-value">-</span>
                }
              </td>
              @if (project === 'OUTBOUND') {
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="width: 90px; min-width: 90px; max-width: 90px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                <p class="mb-0"
                  style="font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{
                  lead?.creatorName || '-' }}</p>
              </td>
              }
              @if((project === 'V-ESTATE' || project === 'IIC-LAB' || project === 'ALL') && (selectedType === 'IVR' ||
              selectedType === 'ALL')){
              <td class="caller-no-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p>{{ lead.callerNo || lead.calledNo || "-" }}</p>
              </td>
              <td class="caller-no-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p class="mb-0">{{ lead.callerId || "-" }}</p>
                @if (getAgentName(lead)) {
                <span class="agent-name-subtext">{{ getAgentName(lead) }}</span>
                }
              </td>
              <td class="direction-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p>{{ lead.callType === 'Notanswered' ? 'Not answered' : (lead.direction || lead.callType || "-") }}</p>
              </td>
              <td class="duration-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p>{{ lead.duration ? lead.duration : "-" }}</p>
              </td>
              }
              <td class="designation-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p style="word-wrap: break-word">
                  {{ lead.designation ? lead.designation : "-" }}
                </p>
              </td>

              <td class="email-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p class="email">{{ getLeadEmail(lead) }}</p>
              </td>
              <td class="contact-no-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p>{{ getLeadPhone(lead) }}</p>
              </td>
              @if(project === 'ALL' || project === 'IIC-LAB' || (project === 'V-ESTATE' && (selectedType === 'Contact
              Us' || selectedType ===
              'Book Demo' ||
              selectedType === 'whatsapp' || selectedType === 'Whatsapp' || selectedType === 'Email' ||
              selectedType === 'ALL'))){
              <td class="utm-source-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p class="utm-cell-text" [matTooltip]="getUtmTooltip(lead, 'utmSource')"
                  matTooltipClass="custom-utm-tooltip" matTooltipPosition="above">
                  {{ getUtmValue(lead, 'utmSource') }}
                </p>
              </td>
              <td class="utm-medium-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p class="utm-cell-text" [matTooltip]="getUtmTooltip(lead, 'utmMedium')"
                  matTooltipClass="custom-utm-tooltip" matTooltipPosition="above">
                  {{ getUtmValue(lead, 'utmMedium') }}
                </p>
              </td>
              <td class="utm-content-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                @if (isUtmApplicable(lead) && lead.utmContent && (lead.utmContent.startsWith('http://') ||
                lead.utmContent.startsWith('https://'))) {
                <a [href]="lead.utmContent" target="_blank" (click)="$event.stopPropagation()"
                  [matTooltip]="lead.utmContent" matTooltipClass="custom-utm-tooltip" matTooltipPosition="above"
                  class="utm-cell-link">
                  {{ lead.utmContent }}
                </a>
                } @else {
                <p class="utm-cell-text" [matTooltip]="getUtmTooltip(lead, 'utmContent')"
                  matTooltipClass="custom-utm-tooltip" matTooltipPosition="above">
                  {{ getUtmValue(lead, 'utmContent') }}
                </p>
                }
              </td>
              <td class="landing-page-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                @if (lead?.landingPage && (lead.landingPage.startsWith('http://') ||
                lead.landingPage.startsWith('https://'))) {
                <a [href]="lead.landingPage" target="_blank" (click)="$event.stopPropagation()"
                  style="display: block; max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #3182ce; text-decoration: underline;">
                  {{ lead.landingPage }}
                </a>
                } @else {
                <p style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px;">{{
                  lead?.landingPage || '-' }}</p>
                }
              </td>
              }


              @if (!isUnQualifiedFilter && (userDepartment !== 'MARKETING' || canAssignLeads)) {
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                @if (lead?.assignedToString) {

                <img src="/assets/leads/edit-icon.png" width="40" alt="Edit Lead" />
                } @else {

                <img src="/assets/leads/assign-icon.png" width="40" alt="Assign Lead" />
                }
              </td>
              }
              @if (canDeleteLeads) {
              <td>
                @if (!isUnQualifiedFilter) {
                <div class="mt-2 position-relative z-1" (click)="deleteLead(lead._id, lead)" style="cursor: pointer">
                  <img src="../../../../assets/leads/delete-lead.png" alt="" width="20" height="20">
                </div>
                }
                @if (isUnQualifiedFilter) {
                <div class="mt-2 position-relative z-1" (click)="restoreLead(lead)" style="cursor: pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.95 8.95 0 0 0 13 21a9 9 0 0 0 0-18m-1 5v5l4.28 2.54l.72-1.21l-3.5-2.08V8z" />
                  </svg>
                </div>
                }
              </td>
              }

            </tr>

            } @if(showNoDataMessage){
            <div class="d-flex justify-content-center" style="
                font-size: 40px;
                width: 100%;
                margin-top: 120px;
                flex-direction: column;
                position: absolute;
              ">
              <img src="../../../assets/no-data.jpg" alt="" width="500px"
                style="position: absolute; left: 33%; top: 15%" />
              <p style="position: absolute; left: 40%; font-size: 30px; bottom: 10%;">
                No Leads Available
              </p>
            </div>
            }
          </tbody>
        </table>
        }
      </div>
    </div>
  </div>
  }
  @if(project === 'IIC-LAB'){
  <div class="leads-listing-banner" [class.marketing-banner]="userDepartment === 'MARKETING'">
    <div class="d-flex align-items-center justify-content-between table-header-flex-wrapper">
      <div class="d-flex align-items-center menu-content-inner">
        <div class="leads-count">
          <p>
            Leads @if(selectedSection === 'Contact Us' || selectedSection === 'ALL' || selectedSection === 'IVR' ||
            selectedSection === 'Whatsapp' || selectedSection === 'Email' || selectedSection === 'Ads'){
            <small class="count-num ml-1 mb-0">({{ this.totalLeads }})</small>
            } @if(selectedSection === 'Newsletter'){
            <small class="count-num ml-1 mb-0">({{ this.newsLetterLength }})</small>
            } @if(selectedSection === 'Career'){
            <small class="count-num ml-1 mb-0">({{ this.careerLength }})</small>
            }
          </p>
        </div>

        @if(selectedSection === 'Contact Us' || selectedSection === 'IVR' || selectedSection === 'Whatsapp' ||
        selectedSection === 'Email' || selectedSection === 'ALL' || selectedSection === 'Ads'){
        <div class="search-box ml-3 position-relative">
          <input type="text" placeholder="Search Leads" [(ngModel)]="searchQuery" (input)="onSearchChange()" />
          <svg class="search-icon position-absolute" width="19" height="19" viewBox="0 0 19 19" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.3233 12.9048C15.5703 11.2971 16.158 9.27482 15.9668 7.24925C15.7757 5.22367 14.82 3.34701 13.2943 2.00104C11.7685 0.655069 9.78735 -0.0590965 7.75375 0.00383158C5.72015 0.0667597 3.7869 0.902055 2.34731 2.33978C0.906468 3.77851 0.068442 5.7125 0.00401015 7.74765C-0.0604217 9.78279 0.65359 11.7659 2.00054 13.2929C3.34749 14.8199 5.22601 15.7758 7.25329 15.9659C9.28056 16.1559 11.304 15.5658 12.9113 14.3158L12.9543 14.3608L17.1963 18.6038C17.2892 18.6967 17.3995 18.7704 17.5209 18.8207C17.6423 18.871 17.7724 18.8968 17.9038 18.8968C18.0352 18.8968 18.1653 18.871 18.2867 18.8207C18.4081 18.7704 18.5184 18.6967 18.6113 18.6038C18.7042 18.5109 18.7779 18.4006 18.8282 18.2792C18.8785 18.1578 18.9044 18.0277 18.9044 17.8963C18.9044 17.7649 18.8785 17.6348 18.8282 17.5134C18.7779 17.392 18.7042 17.2817 18.6113 17.1888L14.3683 12.9468L14.3233 12.9048ZM12.2473 3.75478C12.8119 4.31026 13.2609 4.97203 13.5685 5.70192C13.8761 6.43181 14.0361 7.21537 14.0393 8.0074C14.0425 8.79944 13.8889 9.58428 13.5873 10.3166C13.2857 11.049 12.8421 11.7144 12.282 12.2745C11.7219 12.8345 11.0565 13.2782 10.3242 13.5798C9.59181 13.8814 8.80697 14.035 8.01493 14.0318C7.2229 14.0286 6.43933 13.8686 5.70945 13.561C4.97956 13.2534 4.31779 12.8044 3.76231 12.2398C2.65223 11.1115 2.03297 9.59023 2.03941 8.0074C2.04586 6.42458 2.67749 4.90843 3.79672 3.78919C4.91596 2.66996 6.43211 2.03833 8.01493 2.03188C9.59775 2.02544 11.119 2.6447 12.2473 3.75478Z"
              fill="#999999" />
          </svg>
          @if(searchQuery){
          <img class="search-close" style="cursor: pointer" src="../../../assets/closeIcon.png" alt=""
            (click)="clearSearch()" />
          }
        </div>
        <div class="d-flex align-items-center position-relative header-action-btns">
          @if (canViewDeletedLeads) {
          <button class="btn btn-outline-danger ml-2 unqualified-btn" [class.active]="isDeletedFilter"
            (click)="toggleDeletedFilter()">
            Deleted Leads
          </button>
          }
          @if (isDeletedFilter) {
          <span class="cross-icon" (click)="resetDeletedFilter($event)">
            ✕
          </span>
          }
        </div>

        } @if(selectedSection === 'Career'){
        <div class="search-box ml-3 position-relative">
          <input type="text" placeholder="Search Leads" [(ngModel)]="searchCareerQuery"
            (input)="onSearchCareerChange()" />
          <svg class="search-icon position-absolute" width="19" height="19" viewBox="0 0 19 19" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.3233 12.9048C15.5703 11.2971 16.158 9.27482 15.9668 7.24925C15.7757 5.22367 14.82 3.34701 13.2943 2.00104C11.7685 0.655069 9.78735 -0.0590965 7.75375 0.00383158C5.72015 0.0667597 3.7869 0.902055 2.34731 2.33978C0.906468 3.77851 0.068442 5.7125 0.00401015 7.74765C-0.0604217 9.78279 0.65359 11.7659 2.00054 13.2929C3.34749 14.8199 5.22601 15.7758 7.25329 15.9659C9.28056 16.1559 11.304 15.5658 12.9113 14.3158L12.9543 14.3608L17.1963 18.6038C17.2892 18.6967 17.3995 18.7704 17.5209 18.8207C17.6423 18.871 17.7724 18.8968 17.9038 18.8968C18.0352 18.8968 18.1653 18.871 18.2867 18.8207C18.4081 18.7704 18.5184 18.6967 18.6113 18.6038C18.7042 18.5109 18.7779 18.4006 18.8282 18.2792C18.8785 18.1578 18.9044 18.0277 18.9044 17.8963C18.9044 17.7649 18.8785 17.6348 18.8282 17.5134C18.7779 17.392 18.7042 17.2817 18.6113 17.1888L14.3683 12.9468L14.3233 12.9048ZM12.2473 3.75478C12.8119 4.31026 13.2609 4.97203 13.5685 5.70192C13.8761 6.43181 14.0361 7.21537 14.0393 8.0074C14.0425 8.79944 13.8889 9.58428 13.5873 10.3166C13.2857 11.049 12.8421 11.7144 12.282 12.2745C11.7219 12.8345 11.0565 13.2782 10.3242 13.5798C9.59181 13.8814 8.80697 14.035 8.01493 14.0318C7.2229 14.0286 6.43933 13.8686 5.70945 13.561C4.97956 13.2534 4.31779 12.8044 3.76231 12.2398C2.65223 11.1115 2.03297 9.59023 2.03941 8.0074C2.04586 6.42458 2.67749 4.90843 3.79672 3.78919C4.91596 2.66996 6.43211 2.03833 8.01493 2.03188C9.59775 2.02544 11.119 2.6447 12.2473 3.75478Z"
              fill="#999999" />
          </svg>
          @if(searchCareerQuery){
          <img class="search-close" style="cursor: pointer" src="../../../assets/closeIcon.png" alt=""
            (click)="onClearCareerSearch()" />
          }
        </div>
        <div class="d-flex align-items-center position-relative header-action-btns">
          @if (canViewDeletedLeads) {
          <button class="btn btn-outline-danger ml-2 unqualified-btn" [class.active]="isDeletedFilter"
            (click)="toggleDeletedFilter()">
            Deleted Leads
          </button>
          }
          @if (isDeletedFilter) {
          <span class="cross-icon" (click)="resetDeletedFilter($event)">
            ✕
          </span>
          }
        </div>
        }
        @if(selectedSection === 'Newsletter'){
        <div class="search-box ml-3 position-relative">
          <input type="text" placeholder="Search Leads" [(ngModel)]="searchQuery" (input)="onSearchChange()" />
          <svg class="search-icon position-absolute" width="19" height="19" viewBox="0 0 19 19" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.3233 12.9048C15.5703 11.2971 16.158 9.27482 15.9668 7.24925C15.7757 5.22367 14.82 3.34701 13.2943 2.00104C11.7685 0.655069 9.78735 -0.0590965 7.75375 0.00383158C5.72015 0.0667597 3.7869 0.902055 2.34731 2.33978C0.906468 3.77851 0.068442 5.7125 0.00401015 7.74765C-0.0604217 9.78279 0.65359 11.7659 2.00054 13.2929C3.34749 14.8199 5.22601 15.7758 7.25329 15.9659C9.28056 16.1559 11.304 15.5658 12.9113 14.3158L12.9543 14.3608L17.1963 18.6038C17.2892 18.6967 17.3995 18.7704 17.5209 18.8207C17.6423 18.871 17.7724 18.8968 17.9038 18.8968C18.0352 18.8968 18.1653 18.871 18.2867 18.8207C18.4081 18.7704 18.5184 18.6967 18.6113 18.6038C18.7042 18.5109 18.7779 18.4006 18.8282 18.2792C18.8785 18.1578 18.9044 18.0277 18.9044 17.8963C18.9044 17.7649 18.8785 17.6348 18.8282 17.5134C18.7779 17.392 18.7042 17.2817 18.6113 17.1888L14.3683 12.9468L14.3233 12.9048ZM12.2473 3.75478C12.8119 4.31026 13.2609 4.97203 13.5685 5.70192C13.8761 6.43181 14.0361 7.21537 14.0393 8.0074C14.0425 8.79944 13.8889 9.58428 13.5873 10.3166C13.2857 11.049 12.8421 11.7144 12.282 12.2745C11.7219 12.8345 11.0565 13.2782 10.3242 13.5798C9.59181 13.8814 8.80697 14.035 8.01493 14.0318C7.2229 14.0286 6.43933 13.8686 5.70945 13.561C4.97956 13.2534 4.31779 12.8044 3.76231 12.2398C2.65223 11.1115 2.03297 9.59023 2.03941 8.0074C2.04586 6.42458 2.67749 4.90843 3.79672 3.78919C4.91596 2.66996 6.43211 2.03833 8.01493 2.03188C9.59775 2.02544 11.119 2.6447 12.2473 3.75478Z"
              fill="#999999" />
          </svg>
          @if(searchQuery){
          <img class="search-close" style="cursor: pointer" src="../../../assets/closeIcon.png" alt=""
            (click)="clearSearch()" />
          }
        </div>
        <div class="d-flex align-items-center position-relative header-action-btns">
          @if (canViewDeletedLeads) {
          <button class="btn btn-outline-danger ml-2 unqualified-btn" [class.active]="isDeletedFilter"
            (click)="toggleDeletedFilter()">
            Deleted Leads
          </button>
          }
          @if (isDeletedFilter) {
          <span class="cross-icon" (click)="resetDeletedFilter($event)">
            ✕
          </span>
          }
        </div>

        }

      </div>

      @if (userDepartment === 'MARKETING') {
      <div class="marketing-date-filter position-relative">
        <i class="far fa-calendar-alt calendar-icon-left"></i>
        <input class="date-filter-input fx-date-range" type="text" matInput ngxDaterangepickerMd [locale]="locale"
          [drops]="'down'" [opens]="'left'" [ranges]="ranges" [showCustomRangeLabel]="false"
          [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true" [showCancel]="true"
          [startKey]="'startDate'" [endKey]="'endDate'" [autoApply]="true" autocomplete="off" name="daterange"
          [(ngModel)]="selectedDateRange" (datesUpdated)="onDateSelected($event)" (hide)="onDatepickerHide()"
          placeholder="Select Date" readonly />

        @if(isFilteredView) {
        <button class="btn-clear-date-inside" (click)="clearDateFilter()" title="Clear date filter">
          <i class="fas fa-times"></i>
        </button>
        }
      </div>
      }
    </div>

    <div class=" table-banner mt-4">
      @if(selectedSection === 'Contact Us' || selectedSection === 'IVR' || selectedSection === 'Whatsapp' ||
      selectedSection === 'Email' || selectedSection === 'ALL' || selectedSection === 'Ads'){
      @if(isSpinnerLoader){
      <div class="loader-wrapper">
        <span class="loader"></span>
      </div>
      }
      <div class="demo-tracker-banner" [style.height]="bannerHeight" [style.maxHeight]="bannerHeight" infiniteScroll
        #infiniteScroller [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()"
        [scrollWindow]="false">

        <table class="table leads-content" style="overflow-x: auto; width: 2180px">
          <thead>
            <tr>
              <th scope="col" class="sno-col">S.NO</th>
              <th scope="col" class="date-col">DATE</th>
              <th scope="col" class="name-col">NAME</th>
              <th scope="col" class="source-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="All Sources" [(value)]="selectedSection"
                      panelWidth="auto" panelClass="admin-table-dropdown"
                      (selectionChange)="onSectionChange($event.value)">
                      <mat-option value="ALL" title="All Sources">All Sources</mat-option>
                      <mat-option value="Contact Us" title="Contact Us">Contact Us</mat-option>
                      <mat-option value="Newsletter" title="Newsletter">Newsletter</mat-option>
                      <mat-option value="Career" title="Career">Career</mat-option>
                      <mat-option value="IVR" title="IVR">IVR</mat-option>
                      <mat-option value="Whatsapp" title="Whatsapp">Whatsapp</mat-option>
                      <mat-option value="Email" title="Email">Email</mat-option>
                      <mat-option value="Ads" title="Ads">Ads</mat-option>
                      <mat-option value="Outbound" title="Outbound">Outbound</mat-option>
                    </mat-select>

                  </mat-form-field>
                </div>
              </th>
              <th scope="col" class="user-col">
                @if(selectedSection === 'Contact Us' || selectedSection === 'IVR' || selectedSection === 'Whatsapp' ||
                selectedSection === 'Email' || selectedSection === 'ALL' || selectedSection === 'Ads'){
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="All Users" [(value)]="selectedAssignedUser"
                      panelWidth="auto" panelClass="admin-table-dropdown"
                      (selectionChange)="onAssignedUserChange($event.value)"
                      (openedChange)="onAssigneeFilterOpened($event)">
                      <mat-option value="allUsers" title="All Users">All Users</mat-option>

                      @for (user of iicUsers; track user.id) {
                      <mat-option [value]="user.id" [title]="user.username">{{
                        user.username
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                }
              </th>
              <th scope="col" class="status-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="All Status" [(value)]="selectedOptionStatus"
                      panelWidth="auto" panelClass="admin-table-dropdown" (selectionChange)="onStatusChange()">
                      <mat-option value="" title="All Status">All Status</mat-option>
                      <mat-option value="Not started" title="Not started">Not started</mat-option>
                      <mat-option value="Contacted" title="Contacted">Contacted</mat-option>
                      <mat-option value="Meetings in Video call" title="Meetings in Video call">Meetings in Video
                        call</mat-option>
                      <mat-option value="Meetings in person" title="Meetings in person">Meetings in person</mat-option>
                      <mat-option value="Presentation" title="Presentation">Presentation</mat-option>
                      <mat-option value="Cost sheet" title="Cost sheet">Cost sheet</mat-option>
                      <mat-option value="Closing Pool" title="Closing Pool">Closing Pool</mat-option>
                      <mat-option value="Closed" title="Closed">Closed</mat-option>
                      <mat-option value="Lost" title="Lost">Lost</mat-option>
                      <mat-option value="unassigned" title="Unassigned">Unassigned</mat-option>
                      <mat-option value="Unqualified" title="Unqualified">Unqualified</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              @if(selectedSection === 'IVR' || selectedSection === 'ALL'){
              <th scope="col" class="caller-id-col">CALLER ID</th>
              }
              @if(selectedSection === 'Contact Us' || selectedSection === 'ALL' || selectedSection === 'Whatsapp' ||
              selectedSection === 'Email' || selectedSection === 'Ads'){
              <th scope="col" class="designation-col">DESIGNATION</th>
              }
              @if(selectedSection === 'IVR' || selectedSection === 'ALL'){
              <th scope="col" class="caller-no-col">CALLER NO</th>
              }
              @if(selectedSection === 'Contact Us' || selectedSection === 'ALL' || selectedSection === 'Whatsapp' ||
              selectedSection === 'Email' || selectedSection === 'Ads'){
              <th scope="col" class="email-col">E-MAIL</th>
              }
              @if(selectedSection === 'Contact Us' || selectedSection === 'ALL' || selectedSection === 'Whatsapp' ||
              selectedSection === 'Email' || selectedSection === 'Ads'){
              <th scope="col" class="contact-no-col">CONTACT NO</th>
              }
              @if(selectedSection === 'Contact Us' || selectedSection === 'ALL' || selectedSection === 'Whatsapp' ||
              selectedSection === 'Email' || selectedSection === 'Ads'){
              <th scope="col" class="utm-source-col">UTM SOURCE</th>
              <th scope="col" class="utm-medium-col">UTM MEDIUM</th>
              <th scope="col" class="utm-content-col">UTM CONTENT</th>
              <th scope="col" class="landing-page-col">LANDING PAGE</th>
              }
              @if(selectedSection === 'IVR' || selectedSection === 'ALL'){
              <th scope="col" class="direction-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="Direction" [(value)]="selectedCallFilter"
                      panelWidth="auto" panelClass="admin-table-dropdown" (selectionChange)="onCallFilterChange()">
                      <mat-option value="ALL" title="All">All</mat-option>
                      <mat-option value="Inbound" title="Inbound">Inbound</mat-option>
                      <mat-option value="Outbound" title="Outbound">Outbound</mat-option>
                      <mat-option value="Not answered" title="Not answered">Not answered</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              <th scope="col" class="duration-col">DURATION</th>
              }
              @if (!isUnQualifiedFilter && (userDepartment !== 'MARKETING' || canAssignLeads)) {
              <th scope="col" class="option-col">OPTION</th>

              }
              @if (canDeleteLeads) {
              <th scope="col" class="action-col">ACTION</th>
              }
            </tr>
          </thead>
          <tbody>
            @if(showNoDataMessage){
            <div class="d-flex justify-content-center" style="
                font-size: 40px;
                width: 100%;
                margin-top: 120px;
                flex-direction: column;
                position: absolute;
              ">
              <img src="../../../assets/no-data.jpg" alt="" width="500px"
                style="position: absolute; left: 33%; top: 15%" />
              <p style="position: absolute; left: 40%; font-size: 30px;bottom: 10%;">
                No Leads Available
              </p>
            </div>
            }

            @for(lead of filteredLeads; track lead._id;let i=$index){
            <tr>
              <td>
                <p style="margin-right: 8px; font-weight: 600">
                  {{ i + 1 }}
                </p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                <p class="name mb-0">{{ lead.createdAt | date : "dd-MM-yyyy" }}</p>
                @if (lead?.createdAt) {
                <div class="text-muted small" style="font-size: 11px; margin-top: 1px; font-weight: 400;">
                  ({{ lead?.createdAt | date : "hh:mm a" }})
                </div>
                }
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                <p class="name">{{ (lead.name && lead.name !== getAgentName(lead)) ? lead.name : "-" }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                <p>
                  {{ lead?.source ? lead?.source : "-" }}
                </p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                <p [innerHTML]="getAssignedToDisplay(lead, true)"></p>
              </td>
              <td class="status-col">
                <p [ngClass]="getStatusClass(lead?.status)" title="{{ lead?.status }}">
                  {{ lead?.status ? lead?.status : "-" }}
                </p>
                @if (lead?.deal) {
                <span class="deal-tag" [class.lost]="lead.deal.status === 'cancelled'"
                  [class.won]="lead.deal.status !== 'pipeline' && lead.deal.status !== 'cancelled'"
                  title="Deal in Finance: {{ lead.deal.name }} · {{ lead.deal.status }}">
                  {{ lead.deal.status === 'pipeline' ? 'Pipeline deal' : (lead.deal.status === 'cancelled' ? 'Deal lost'
                  : 'Deal won') }}
                </span>
                }
              </td>
              @if(selectedSection === 'IVR' || selectedSection === 'ALL'){
              <td class="caller-id-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p class="mb-0">{{ lead.callerId || "-" }}</p>
                @if (getAgentName(lead)) {
                <span class="agent-name-subtext">{{ getAgentName(lead) }}</span>
                }
              </td>
              }
              @if(selectedSection === 'Contact Us' || selectedSection === 'ALL' || selectedSection === 'Whatsapp' ||
              selectedSection === 'Email' || selectedSection === 'Ads'){
              <td class="designation-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p>{{ lead.designation || "-" }}</p>
              </td>
              }
              @if(selectedSection === 'IVR' || selectedSection === 'ALL'){
              <td class="caller-no-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p>{{ lead.callerNo || lead.calledNo || "-" }}</p>
              </td>
              }
              @if(selectedSection === 'Contact Us' || selectedSection === 'ALL' || selectedSection === 'Whatsapp' ||
              selectedSection === 'Email' || selectedSection === 'Ads'){
              <td class="email-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p>{{ getLeadEmail(lead) }}</p>
              </td>
              }
              @if(selectedSection === 'Contact Us' || selectedSection === 'ALL' || selectedSection === 'Whatsapp' ||
              selectedSection === 'Email' || selectedSection === 'Ads'){
              <td class="contact-no-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p>{{ getLeadPhone(lead) }}</p>
              </td>
              }
              @if(selectedSection === 'Contact Us' || selectedSection === 'ALL' || selectedSection === 'Whatsapp' ||
              selectedSection === 'Email' || selectedSection === 'Ads'){
              <td class="utm-source-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p class="utm-cell-text" [matTooltip]="getUtmTooltip(lead, 'utmSource')"
                  matTooltipClass="custom-utm-tooltip" matTooltipPosition="above">
                  {{ getUtmValue(lead, 'utmSource') }}
                </p>
              </td>
              <td class="utm-medium-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p class="utm-cell-text" [matTooltip]="getUtmTooltip(lead, 'utmMedium')"
                  matTooltipClass="custom-utm-tooltip" matTooltipPosition="above">
                  {{ getUtmValue(lead, 'utmMedium') }}
                </p>
              </td>
              <td class="utm-content-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                @if (isUtmApplicable(lead) && lead.utmContent && (lead.utmContent.startsWith('http://') ||
                lead.utmContent.startsWith('https://'))) {
                <a [href]="lead.utmContent" target="_blank" (click)="$event.stopPropagation()"
                  [matTooltip]="lead.utmContent" matTooltipClass="custom-utm-tooltip" matTooltipPosition="above"
                  class="utm-cell-link">
                  {{ lead.utmContent }}
                </a>
                } @else {
                <p class="utm-cell-text" [matTooltip]="getUtmTooltip(lead, 'utmContent')"
                  matTooltipClass="custom-utm-tooltip" matTooltipPosition="above">
                  {{ getUtmValue(lead, 'utmContent') }}
                </p>
                }
              </td>
              <td class="landing-page-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                @if (lead?.landingPage && (lead.landingPage.startsWith('http://') ||
                lead.landingPage.startsWith('https://'))) {
                <a [href]="lead.landingPage" target="_blank" (click)="$event.stopPropagation()"
                  style="display: block; max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #3182ce; text-decoration: underline;">
                  {{ lead.landingPage }}
                </a>
                } @else {
                <p style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px;">{{
                  lead?.landingPage || '-' }}</p>
                }
              </td>
              }

              @if(selectedSection === 'IVR' || selectedSection === 'ALL'){
              <td class="direction-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p>{{ lead.callType === 'Notanswered' ? 'Not answered' : (lead.direction || "-") }}</p>
              </td>
              <td class="duration-col" data-toggle="modal" data-target="#contactLeadDetail"
                (click)="singleLeadDetails(lead._id)">
                <p>{{ lead.duration ? lead.duration : "-" }}</p>
              </td>
              }

              <!-- <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                @if (lead?.customerValue) {
                <span class="badge-pill {{ getBadgeClass(lead?.customerValue) }}">
                  {{ lead.customerValue ? lead.customerValue : "-" }}
                </span>
                } @else {
                <span class="customer-value">-</span>
                }
              </td> -->



              @if (!isUnQualifiedFilter && (userDepartment !== 'MARKETING' || canAssignLeads)) {
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)">
                @if (lead?.assignedToString) {
                <img src="/assets/leads/edit-icon.png" width="40" alt="Edit Lead" />
                } @else {

                <img src="/assets/leads/assign-icon.png" width="40" alt="Assign Lead" />
                }
              </td>
              }
              @if (canDeleteLeads) {
              <td>
                @if (!isUnQualifiedFilter) {
                <div class="mt-2 position-relative z-1" (click)="deleteLead(lead._id, lead)" style="cursor: pointer">
                  <img src="../../../../assets/leads/delete-lead.png" alt="" width="20" height="20">
                </div>
                }
                @if (isUnQualifiedFilter) {
                <div class="mt-2 position-relative z-1" (click)="restoreLead(lead)" style="cursor: pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.95 8.95 0 0 0 13 21a9 9 0 0 0 0-18m-1 5v5l4.28 2.54l.72-1.21l-3.5-2.08V8z" />
                  </svg>
                </div>
                }
              </td>
              }

            </tr>
            }
          </tbody>
        </table>

      </div>
      @if(!showNoDataMessage && !isSpinnerLoader){ } }
      @if(selectedSection ==='Newsletter'){
      <div class="demo-tracker-banner" [style.height]="bannerHeight" [style.maxHeight]="bannerHeight" infiniteScroll
        #infiniteScroller [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()"
        [scrollWindow]="false">
        @if(isSpinnerLoader){
        <div class="loader-wrapper">
          <span class="loader"></span>
        </div>
        }

        <table class="table leads-content" style="overflow-x: auto; width: 2180px">
          <thead>
            <tr>
              <th scope="col">S.NO</th>
              <th scope="col">DATE</th>
              <th scope="col" style="width: 140px">NAME</th>
              <th scope="col" class="source-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="Newsletter" [(value)]="selectedSection"
                      panelWidth="auto" panelClass="admin-table-dropdown"
                      (selectionChange)="onSectionChange($event.value)">
                      <mat-option value="ALL" title="ALL">ALL</mat-option>
                      <mat-option value="Contact Us" title="Contact Us">Contact Us</mat-option>
                      <mat-option value="Newsletter" title="Newsletter">Newsletter</mat-option>
                      <mat-option value="Career" title="Career">Career</mat-option>
                      <mat-option value="IVR" title="IVR">IVR</mat-option>
                    </mat-select>

                  </mat-form-field>
                </div>
              </th>
              <th scope="col" class="user-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="All Users" [(value)]="selectedAssignedUser"
                      panelWidth="auto" panelClass="admin-table-dropdown"
                      (selectionChange)="onAssignedUserChange($event.value)"
                      (openedChange)="onAssigneeFilterOpened($event)">
                      <mat-option value="allUsers" title="All Users">All Users</mat-option>

                      @for (user of iicUsers; track user.id) {
                      <mat-option [value]="user.id" [title]="user.username">{{
                        user.username
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              <th scope="col" class="status-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="All Status" [(value)]="selectedOptionStatus"
                      panelWidth="auto" panelClass="admin-table-dropdown" (selectionChange)="onStatusChange()">
                      <mat-option value="" title="All Status">All Status</mat-option>
                      <mat-option value="Not started" title="Not started">Not started</mat-option>
                      <mat-option value="Contacted" title="Contacted">Contacted</mat-option>
                      <mat-option value="Meetings in Video call" title="Meetings in Video call">Meetings in Video
                        call</mat-option>
                      <mat-option value="Meetings in person" title="Meetings in person">Meetings in person</mat-option>
                      <mat-option value="Presentation" title="Presentation">Presentation</mat-option>
                      <mat-option value="Cost sheet" title="Cost sheet">Cost sheet</mat-option>
                      <mat-option value="Closing Pool" title="Closing Pool">Closing Pool</mat-option>
                      <mat-option value="Closed" title="Closed">Closed</mat-option>
                      <mat-option value="Lost" title="Lost">Lost</mat-option>
                      <mat-option value="unassigned" title="Unassigned">Unassigned</mat-option>
                      <mat-option value="Unqualified" title="Unqualified">Unqualified</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              <th scope="col" class="designation-col">DESIGNATION</th>
              <th scope="col" class="email-col">E-MAIL</th>
              <th scope="col" class="contact-no-col">CONTACT NO</th>
              @if (canDeleteLeads) {
              <th scope="col" style="width: 200px">ACTION</th>
              }
            </tr>
          </thead>
          <tbody>
            @if(showNoDataMessage){
            <div class="d-flex justify-content-center" style="
                font-size: 40px;
                width: 100%;
                margin-top: 120px;
                flex-direction: column;
                position: absolute;
              ">
              <img src="../../../assets/no-data.jpg" alt="" width="500px"
                style="position: absolute; left: 33%; top: 15%" />
              <p style="position: absolute; left: 40%; font-size: 30px; bottom: 10%;">
                No Leads Available
              </p>
            </div>
            }

            @for(lead of newsLetter; track lead._id;let i=$index){
            <tr>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p style="margin-right: 8px; font-weight: 600">
                  {{ i + 1 }}
                </p>
              </td>
              <td class="" data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p class="name mb-0">{{ lead.createdAt | date : "dd-MM-yyyy" }}</p>
                @if (lead?.createdAt) {
                <div class="text-muted small" style="font-size: 11px; margin-top: 1px; font-weight: 400;">
                  ({{ lead?.createdAt | date : "hh:mm a" }})
                </div>
                }
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p class="name">{{ lead.name ? lead.name : "-" }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p>{{ lead.source ? lead.source : "-" }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p [innerHTML]="getAssignedToDisplay(lead, true)"></p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p>{{ lead.status ? lead.status : "-" }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p class="">
                  {{ lead.designation ? lead.designation : "-" }}
                </p>
              </td>

              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p>{{ getLeadEmail(lead) }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p>{{ getLeadPhone(lead) }}</p>
              </td>
              @if (canDeleteLeads) {
              <td>
                @if (!isUnQualifiedFilter) {
                @if (userDepartment !== 'MARKETING' || canAssignLeads) {
                <div class="mt-2 position-relative z-1 d-inline-block mr-2" data-toggle="modal"
                  data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)" style="cursor: pointer">
                  @if (lead?.assignedToString) {
                  <img src="/assets/leads/edit-icon.png" width="40" alt="Edit Lead" />
                  } @else {
                  <img src="/assets/leads/assign-icon.png" width="40" alt="Assign Lead" />
                  }
                </div>
                }
                <div class="mt-2 position-relative z-1 d-inline-block" (click)="deleteIICLead(lead._id)"
                  style="cursor: pointer">
                  <img src="../../../../assets/leads/delete-lead.png" alt="" width="20" height="20">
                </div>
                }
                @if(isUnQualifiedFilter) {
                <div class="mt-2 position-relative z-1" (click)="restoreIICLead(lead._id)" style="cursor: pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.95 8.95 0 0 0 13 21a9 9 0 0 0 0-18m-1 5v5l4.28 2.54l.72-1.21l-3.5-2.08V8z" />
                  </svg>
                </div>
                }
              </td>
              }
            </tr>
            }
          </tbody>
        </table>

      </div>
      @if(!showNoDataMessage && !isSpinnerLoader){ } }
      @if(selectedSection ==='Career'){
      <div class="demo-tracker-banner" [style.height]="bannerHeight" [style.maxHeight]="bannerHeight" infiniteScroll
        #infiniteScroller [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()"
        [scrollWindow]="false">
        @if(isSpinnerLoader){
        <div class="loader-wrapper">
          <span class="loader"></span>
        </div>
        }

        <table class="table leads-content" style="overflow-x: auto; width: 2180px">
          <thead>
            <tr>
              <th scope="col">S.NO</th>
              <th scope="col">DATE</th>
              <th scope="col" style="width: 140px">NAME</th>
              <th scope="col" class="source-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="Career" [(value)]="selectedSection"
                      panelWidth="auto" panelClass="admin-table-dropdown"
                      (selectionChange)="onSectionChange($event.value)">
                      <mat-option value="ALL" title="ALL">ALL</mat-option>
                      <mat-option value="Contact Us" title="Contact Us">Contact Us</mat-option>
                      <mat-option value="Newsletter" title="Newsletter">Newsletter</mat-option>
                      <mat-option value="Career" title="Career">Career</mat-option>
                      <mat-option value="IVR" title="IVR">IVR</mat-option>
                    </mat-select>

                  </mat-form-field>
                </div>
              </th>
              <th scope="col" class="user-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="All Users" [(value)]="selectedAssignedUser"
                      panelWidth="auto" panelClass="admin-table-dropdown"
                      (selectionChange)="onAssignedUserChange($event.value)"
                      (openedChange)="onAssigneeFilterOpened($event)">
                      <mat-option value="allUsers" title="All Users">All Users</mat-option>

                      @for (user of iicUsers; track user.id) {
                      <mat-option [value]="user.id" [title]="user.username">{{
                        user.username
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              <th scope="col" class="status-col">
                <div class="mat-dropdown-panel">
                  <mat-form-field>
                    <mat-select class="all-filter-select" placeholder="All Status" [(value)]="selectedOptionStatus"
                      panelWidth="auto" panelClass="admin-table-dropdown" (selectionChange)="onStatusChange()">
                      <mat-option value="" title="All Status">All Status</mat-option>
                      <mat-option value="Not started" title="Not started">Not started</mat-option>
                      <mat-option value="Contacted" title="Contacted">Contacted</mat-option>
                      <mat-option value="Meetings in Video call" title="Meetings in Video call">Meetings in Video
                        call</mat-option>
                      <mat-option value="Meetings in person" title="Meetings in person">Meetings in person</mat-option>
                      <mat-option value="Presentation" title="Presentation">Presentation</mat-option>
                      <mat-option value="Cost sheet" title="Cost sheet">Cost sheet</mat-option>
                      <mat-option value="Closing Pool" title="Closing Pool">Closing Pool</mat-option>
                      <mat-option value="Closed" title="Closed">Closed</mat-option>
                      <mat-option value="Lost" title="Lost">Lost</mat-option>
                      <mat-option value="unassigned" title="Unassigned">Unassigned</mat-option>
                      <mat-option value="Unqualified" title="Unqualified">Unqualified</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              <th scope="col" class="designation-col">DESIGNATION</th>
              <th scope="col" class="email-col">E-MAIL</th>
              <th scope="col" class="contact-no-col">CONTACT NO</th>
              @if (canDeleteLeads) {
              <th scope="col" style="width: 200px">ACTION</th>
              }
            </tr>
          </thead>
          <tbody>
            @if(showNoDataMessage){
            <div class="d-flex justify-content-center" style="
                font-size: 40px;
                width: 100%;
                margin-top: 120px;
                flex-direction: column;
                position: absolute;
              ">
              <img src="../../../assets/no-data.jpg" alt="" width="500px"
                style="position: absolute; left: 33%; top: 15%" />
              <p style="position: absolute; left: 40%; font-size: 30px; bottom: 10%;">
                No Leads Available
              </p>
            </div>
            }

            @for(lead of careersList; track lead._id;let i=$index){
            <tr>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p style="margin-right: 8px; font-weight: 600">
                  {{ i + 1 }}
                </p>
              </td>
              <td class="" data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p class="name mb-0">{{ lead.createdAt | date : "dd-MM-yyyy" }}</p>
                @if (lead?.createdAt) {
                <div class="text-muted small" style="font-size: 11px; margin-top: 1px; font-weight: 400;">
                  ({{ lead?.createdAt | date : "hh:mm a" }})
                </div>
                }
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p class="name">{{ lead.name ? lead.name : "-" }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p>{{ lead.source ? lead.source : "-" }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p [innerHTML]="getAssignedToDisplay(lead, true)"></p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p>{{ lead.status ? lead.status : "-" }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p class="">
                  {{ lead.designation ? lead.designation : "-" }}
                </p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p>{{ getLeadEmail(lead) }}</p>
              </td>
              <td data-toggle="modal" data-target="#contactLeadDetail" (click)="singleLeadDetails(lead._id)"
                style="cursor: pointer">
                <p>{{ getLeadPhone(lead) }}</p>
              </td>
              @if (canDeleteLeads) {
              <td>
                @if (!isUnQualifiedFilter) {
                <div class="mt-2 position-relative z-1" (click)="deleteIICLead(lead._id)" style="cursor: pointer">
                  <img src="../../../../assets/leads/delete-lead.png" alt="" width="20" height="20">
                </div>
                }
                @if(isUnQualifiedFilter) {
                <div class="mt-2 position-relative z-1" (click)="restoreIICLead(lead._id)" style="cursor: pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.95 8.95 0 0 0 13 21a9 9 0 0 0 0-18m-1 5v5l4.28 2.54l.72-1.21l-3.5-2.08V8z" />
                  </svg>
                </div>
                }
              </td>
              }
            </tr>
            }
          </tbody>
        </table>

      </div>
      @if(!showNoDataMessage && !isSpinnerLoader){ } }
    </div>
  </div>
  }
</div>
} @if(showCanvasUI) {
<div class="lead-canvas-wrapper">
  <!-- HEADER -->
  <div class="canvas-header d-flex justify-content-between align-items-center">
    <div class="canvas-header-left d-flex align-items-center">
      @if (projectIcons[project]) {
      <div class="project-logo-container">
        <img class="project-logo" [src]="projectIcons[project]" alt="Logo" />
      </div>
      } @else {
      <div class="canvas-header-icon-box">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      </div>
      }
      <div class="canvas-title-block">
        <h3 class="canvas-title">{{ canvasTitle }}</h3>
        <p class="canvas-subtitle">
          See Your Latest Updates Of Your <span>Leads</span>
        </p>
      </div>
    </div>

    <div class="canvas-header-right d-flex align-items-center">
      <div class="search-box kanban-search position-relative">
        <input type="text" placeholder="Search Assigned Leads" [(ngModel)]="kanbanSearchQuery"
          (input)="onKanbanSearchChange()" />
        <svg class="search-icon position-absolute" width="18" height="18" viewBox="0 0 19 19" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M14.3233 12.9048C15.5703 11.2971 16.158 9.27482 15.9668 7.24925C15.7757 5.22367 14.82 3.34701 13.2943 2.00104C11.7685 0.655069 9.78735 -0.0590965 7.75375 0.00383158C5.72015 0.0667597 3.7869 0.902055 2.34731 2.33978C0.906468 3.77851 0.068442 5.7125 0.00401015 7.74765C-0.0604217 9.78279 0.65359 11.7659 2.00054 13.2929C3.34749 14.8199 5.22601 15.7758 7.25329 15.9659C9.28056 16.1559 11.304 15.5658 12.9113 14.3158L12.9543 14.3608L17.1963 18.6038C17.2892 18.6967 17.3995 18.7704 17.5209 18.8207C17.6423 18.871 17.7724 18.8968 17.9038 18.8968C18.0352 18.8968 18.1653 18.871 18.2867 18.8207C18.4081 18.7704 18.5184 18.6967 18.6113 18.6038C18.7042 18.5109 18.7779 18.4006 18.8282 18.2792C18.8785 18.1578 18.9044 18.0277 18.9044 17.8963C18.9044 17.7649 18.8785 17.6348 18.8282 17.5134C18.7779 17.392 18.7042 17.2817 18.6113 17.1888L14.3683 12.9468L14.3233 12.9048ZM12.2473 3.75478C12.8119 4.31026 13.2609 4.97203 13.5685 5.70192C13.8761 6.43181 14.0361 7.21537 14.0393 8.0074C14.0425 8.79944 13.8889 9.58428 13.5873 10.3166C13.2857 11.049 12.8421 11.7144 12.282 12.2745C11.7219 12.8345 11.0565 13.2782 10.3242 13.5798C9.59181 13.8814 8.80697 14.035 8.01493 14.0318C7.2229 14.0286 6.43933 13.8686 5.70945 13.561C4.97956 13.2534 4.31779 12.8044 3.76231 12.2398C2.65223 11.1115 2.03297 9.59023 2.03941 8.0074C2.04586 6.42458 2.67749 4.90843 3.79672 3.78919C4.91596 2.66996 6.43211 2.03833 8.01493 2.03188C9.59775 2.02544 11.119 2.6447 12.2473 3.75478Z"
            fill="#999999" />
        </svg>
        @if(kanbanSearchQuery){
        <img class="search-close" style="cursor: pointer" src="../../../assets/closeIcon.png" alt="Clear search"
          (click)="clearKanbanSearch()" />
        }
      </div>

      <div class="dropdown customervalue-dropdown">
        <button class="btn btn-outline-primary dropdown-toggle d-flex align-items-center" type="button"
          (click)="toggleCustomerValueDropdown($event)">
          <span>{{ customerValueFilterLabel }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
            style="flex-shrink: 0; margin-left: 4px;">
            <path fill="currentColor" d="m12 15l5-5H7z" />
          </svg>
        </button>

        <ul class="dropdown-menu dropdown-menu-end" [class.show]="isCustomerValueDropdownOpen">
          <li>
            <a class="dropdown-item" [class.active]="selectedCustomerValue === ''"
              (click)="applyCustomerValueFilter('')">
              All Badges
            </a>
          </li>
          <li>
            <a class="dropdown-item" [class.active]="selectedCustomerValue === 'Premium'"
              (click)="applyCustomerValueFilter('Premium')">
              Premium
            </a>
          </li>
          <li>
            <a class="dropdown-item" [class.active]="selectedCustomerValue === 'Emerging'"
              (click)="applyCustomerValueFilter('Emerging')">
              Emerging
            </a>
          </li>
          <li>
            <a class="dropdown-item" [class.active]="selectedCustomerValue === 'Basic'"
              (click)="applyCustomerValueFilter('Basic')">
              Basic
            </a>
          </li>
          <li>
            <a class="dropdown-item" [class.active]="selectedCustomerValue === 'Regular'"
              (click)="applyCustomerValueFilter('Regular')">
              Regular
            </a>
          </li>
        </ul>
      </div>

      <div class="dropdown daterange-dropdown">
        <button class="btn btn-outline-primary dropdown-toggle d-flex align-items-center" type="button"
          (click)="toggleDateDropdown($event)">
          <span>{{ dateFilterLabel }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
            style="flex-shrink: 0; margin-left: 4px;">
            <path fill="currentColor" d="m12 15l5-5H7z" />
          </svg>
        </button>

        <ul class="dropdown-menu dropdown-menu-end" [class.show]="isDateDropdownOpen">
          <li>
            <a class="dropdown-item" [class.active]="dateFilterKey === 'all'" (click)="applyDateFilter('all')">
              All Time
            </a>
          </li>

          <li>
            <a class="dropdown-item" [class.active]="dateFilterKey === '30'" (click)="applyDateFilter('30')">
              Last 30 Days
            </a>
          </li>

          <li>
            <a class="dropdown-item" [class.active]="dateFilterKey === '60'" (click)="applyDateFilter('60')">
              Last 60 Days
            </a>
          </li>

          <li>
            <a class="dropdown-item" [class.active]="dateFilterKey === '90'" (click)="applyDateFilter('90')">
              Last 90 Days
            </a>
          </li>
        </ul>
      </div>



      <button class="btn-back d-flex align-items-center" (click)="toggleSortOrder()">

        @if(sortOrder === -1){
        <span><svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M12 4a1 1 0 0 1 1 1v11.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L11 16.586V5a1 1 0 0 1 1-1" />
          </svg>Sort by Oldest</span>
        } @if(sortOrder === 1){
        <span><svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M5.23 10.64a1 1 0 0 0 1.41.13L11 7.14V19a1 1 0 0 0 2 0V7.14l4.36 3.63a1 1 0 1 0 1.28-1.54l-6-5l-.15-.09l-.13-.07a1 1 0 0 0-.72 0l-.13.07l-.15.09l-6 5a1 1 0 0 0-.13 1.41" />
          </svg> Sort by Newest</span>
        }
      </button>
      <button class="btn-back d-flex align-items-center" (click)="goBackToLeads()">
        <span class="btn-back-icon">
          <span class="dot"></span><span class="dot"></span>
          <span class="dot"></span><span class="dot"></span>
        </span>
        <span class="back-dash">Dashboard</span>
      </button>

      <!-- <button class="btn-save ml-3">✓ Save Changes</button> -->
    </div>
  </div>

  <hr class="canvas-divider" />

  <!-- MAIN SCROLL WRAPPER-->
  <div class="canvas-scroll-container" (scroll)="onCanvasScroll($event)">
    <!-- TABS -->
    <div class="canvas-tabs d-flex">
      @for (tab of canvasTabs; track tab.id; let i = $index) {
      <div class="canvas-tab" (click)="scrollToColumn(i)" [class.active]="activeTabIndex === i"
        style="cursor: pointer;">
        <img [ngClass]="{ 'lost-img': tab.isDanger, 'closing-pool-img': tab.isClosingPool }" [src]="tab.icon"
          width="42" />
        <p class="mb-0" [ngClass]="{
    'lost-text': tab.isDanger,
     'unqualified-text': tab.isUnqualified,
    'success-text': tab.isSuccess,
    'progress-text': tab.isProgress,
    'not-started-text': tab.notStarted,
    'closing-pool-text': tab.isClosingPool
  }">
          {{ tab.label }} ({{ totalStatusCount[tab.status] || 0 }})
        </p>
      </div>
      }
    </div>

    <!-- COLUMN WRAPPER -->
    <div class="canvas-columns">
      <!-- FOLLOW-UP TASK COLUMN (BEFORE NOT STARTED) -->
      <div class="canvas-column sticky-column" id="follow-up-task-list">
        @if (isCanvasLoading) {
        <div class="w-100 shimmer-wrapper">
          @for (i of [1,2,3,4,5]; track i) {
          <div class="assigned-card shimmer-card mb-3">
            <div class="shimmer-line w-50"></div>
            <div class="shimmer-line w-75 mt-4"></div>
            <div class="shimmer-line w-60 mt-4"></div>
            <div class="shimmer-line w-40 mt-4"></div>
          </div>
          }
        </div>
        }
        @for (lead of followUpLeadsCanvas; track lead._id) {
        <div class="assigned-card mb-2">
          <!-- CARD HEADER & CLICK TO OPEN DETAIL PANEL -->
          <div (click)="openDetailsPanel(lead); selectLeadInCanvas(lead)">
            <div class="card-header-top mb-2">
              <div>
                @if(lead?.project || project || isOutboundLead(lead)){
                <span class="project-pill-badge" [ngClass]="{
                  'badge-iic-lab': getLeadProjectBadge(lead) === 'IIC-LAB',
                  'badge-v-retail': getLeadProjectBadge(lead) === 'V-RETAIL',
                  'badge-v-estate': getLeadProjectBadge(lead) === 'V-ESTATE',
                  'badge-outbound': getLeadProjectBadge(lead) === 'OUTBOUND'
                }">{{ getLeadProjectBadge(lead) }}</span>
                }
              </div>

              <div class="d-flex align-items-center">
                @if(lead?.hasClosingPotential){
                <span class="closing-pool-badge-pill mr-1" title="In Closing Pool">🦄</span>
                }
                @if(lead?.customerValue || lead?.badge){
                <div class="badge-pill {{ getBadgeClass(lead?.customerValue || lead?.badge) }}">
                  {{ lead.customerValue || lead.badge }}
                </div>
                }
                <button type="button" class="btn btn-accordion-toggle ml-2" (click)="toggleAccordion(lead, $event)">
                  <svg width="14" height="8" viewBox="0 0 14 8" [class.rotate-180]="expandedLeadId === lead._id">
                    <path d="M1 1L7 7L13 1" stroke="#425166" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- LEAD IDENTITY (AVATAR + NAME) -->
            <div class="card-lead-identity mb-2">
              <div class="lead-avatar-box">
                <img [src]="lead?.companyProfileImg || '/assets/leads/default-icon.png'" alt="Avatar" />
              </div>
              <div class="lead-name-box">
                @if (lead?.companyName && lead?.companyName !== '-' && lead?.companyName !== lead?.name) {
                <p class="lead-company-name mb-0">{{ lead?.companyName }}</p>
                }
                <h5 class="lead-person-name mb-0">{{ lead?.name || lead?.companyName || "-" }}</h5>
              </div>
            </div>

            <!-- SUMMARY MIDDLE CARD (VISIBLE WHEN COLLAPSED) -->
            @if (expandedLeadId !== lead._id) {
            <div class="card-summary-box mb-1">
              <div class="summary-assignee-col">
                <img class="assignee-avatar"
                  [src]="lead?.assignedTo?.assignedByImg || lead?.assignedTo?.userProfileImg || '/assets/leads/user-icon.png'"
                  (error)="onImgError($event, '/assets/leads/user-icon.png')" alt="Assignee" />
                <div class="assignee-text-group">
                  <span class="summary-label">Assigned To</span>
                  <p class="summary-assignee-name" [innerHTML]="getAssignedToDisplay(lead, true)"></p>
                </div>
              </div>

              <div class="summary-divider"></div>

              <div class="summary-meta-col">
                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Assigned On</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.assignedTo?.assignedOn) }}</p>
                  </div>
                </div>

                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Last Activity</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.updatedAt) }}</p>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>

      <div class="canvas-column sticky-column" id="assigned-list">
        @if (isCanvasLoading) {
        <div class="w-100 shimmer-wrapper">
          @for (i of [1,2,3,4,5]; track i) {
          <div class="assigned-card shimmer-card mb-3">
            <div class="shimmer-line w-50"></div>


            <div class="shimmer-line w-75 mt-4"></div>

            <div class="shimmer-line w-60 mt-4"></div>

            <div class="shimmer-line w-40 mt-4"></div>
          </div>
          }
        </div>
        } @for (lead of assignedLeadsCanvas; track lead._id) {
        <div class="assigned-card mb-2">
          <!-- CARD HEADER & CLICK TO OPEN DETAIL PANEL -->
          <div (click)="openDetailsPanel(lead); selectLeadInCanvas(lead)">
            <div class="card-header-top mb-2">
              <div>
                @if(lead?.project || project || isOutboundLead(lead)){
                <span class="project-pill-badge" [ngClass]="{
                  'badge-iic-lab': getLeadProjectBadge(lead) === 'IIC-LAB',
                  'badge-v-retail': getLeadProjectBadge(lead) === 'V-RETAIL',
                  'badge-v-estate': getLeadProjectBadge(lead) === 'V-ESTATE',
                  'badge-outbound': getLeadProjectBadge(lead) === 'OUTBOUND'
                }">{{ getLeadProjectBadge(lead) }}</span>
                }
              </div>

              <div class="d-flex align-items-center">
                @if(lead?.hasClosingPotential){
                <span class="closing-pool-badge-pill mr-1" title="In Closing Pool">🦄</span>
                }
                @if(lead?.customerValue || lead?.badge){
                <div class="badge-pill {{ getBadgeClass(lead?.customerValue || lead?.badge) }}">
                  {{ lead.customerValue || lead.badge }}
                </div>
                }
                <button type="button" class="btn btn-accordion-toggle ml-2" (click)="toggleAccordion(lead, $event)">
                  <svg width="14" height="8" viewBox="0 0 14 8" [class.rotate-180]="expandedLeadId === lead._id">
                    <path d="M1 1L7 7L13 1" stroke="#425166" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- LEAD IDENTITY (AVATAR + NAME) -->
            <div class="card-lead-identity mb-2">
              <div class="lead-avatar-box">
                <img [src]="lead?.companyProfileImg || '/assets/leads/default-icon.png'" alt="Avatar" />
              </div>
              <div class="lead-name-box">
                @if (lead?.companyName && lead?.companyName !== '-' && lead?.companyName !== lead?.name) {
                <p class="lead-company-name mb-0">{{ lead?.companyName }}</p>
                }
                <h5 class="lead-person-name mb-0">{{ lead?.name || lead?.companyName || "-" }}</h5>
              </div>
            </div>

            <!-- SUMMARY MIDDLE CARD (VISIBLE WHEN COLLAPSED) -->
            @if (expandedLeadId !== lead._id) {
            <div class="card-summary-box mb-1">
              <div class="summary-assignee-col">
                <img class="assignee-avatar assigned-img" [src]="getAssignedByImg(lead)" (error)="onImgError($event)"
                  alt="Assignee" />
                <div class="assignee-text-group">
                  <span class="summary-label">Assigned To</span>
                  <p class="summary-assignee-name" [innerHTML]="getAssignedToDisplay(lead, true)"></p>
                </div>
              </div>

              <div class="summary-divider"></div>

              <div class="summary-meta-col">
                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Assigned On</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.assignedTo?.assignedOn) }}</p>
                  </div>
                </div>

                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Last Activity</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.updatedAt) }}</p>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>

          <!-- ACCORDION EXPANDED DETAILS -->
          @if(expandedLeadId === lead._id){
          <div class="card-expanded-section mt-3 pt-2" (click)="openDetailsPanel(lead); selectLeadInCanvas(lead)">

            <!-- Section 1: Basic Information -->
            <div class="section-divider-header">
              <div class="section-header-left">
                <div class="section-icon-badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <span class="section-title-text">Basic Information</span>
              </div>
              <div class="section-header-line"></div>
            </div>

            <div class="basic-info-grid mb-3">
              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Name</span>
                  <p class="field-value">{{ lead?.name || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Job Role</span>
                  <p class="field-value">{{ lead?.designation || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Created</span>
                  <p class="field-value">{{ lead?.createdAt | date : "MMMM d, yyyy" }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                    </path>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Next Follow Up</span>
                  <p class="field-value">{{ lead?.followUpDate ? (lead.followUpDate | date : "MMMM d, yyyy") : '-' }}
                  </p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Email</span>
                  <p class="field-value text-truncate">{{ getLeadEmail(lead) || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                    </path>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Phone</span>
                  <p class="field-value">{{ getLeadPhone(lead) }}</p>
                </div>
              </div>
            </div>

            <!-- Section 2: Assignment Details -->
            <div class="section-divider-header">
              <div class="section-header-left">
                <div class="section-icon-badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                  </svg>
                </div>
                <span class="section-title-text">Assignment Details</span>
              </div>
              <div class="section-header-line"></div>
            </div>

            <div class="card-summary-box expanded-assignment-box mt-2">
              <div class="summary-assignee-col">
                <img class="assignee-avatar assigned-img" [src]="getAssignedByImg(lead)" (error)="onImgError($event)"
                  alt="Assignee" />
                <div class="assignee-text-group">
                  <span class="summary-label">Assigned To</span>
                  <p class="summary-assignee-name" [innerHTML]="getAssignedToDisplay(lead, true)"></p>
                </div>
              </div>

              <div class="summary-divider"></div>

              <div class="summary-meta-col">
                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Assigned On</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.assignedTo?.assignedOn) }}</p>
                  </div>
                </div>

                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Last Activity</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.updatedAt) }}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
          }
        </div>

        }
      </div>

      @for (col of emptyColumns; track col.index) {
      <div class="canvas-column" id="drop-list-{{ col.index }}">
        @if (isCanvasLoading) {
        <div class="w-100 shimmer-wrapper">
          @for (i of [1,2,3,4,5]; track i) {
          <div class="assigned-card shimmer-card mb-3">
            <div class="shimmer-line w-50"></div>

            <div class="shimmer-line w-75 mt-4"></div>

            <div class="shimmer-line w-60 mt-4"></div>

            <div class="shimmer-line w-40 mt-4"></div>
          </div>
          }
        </div>
        } @for (item of col.items; track item._id) {
        <div class="assigned-card mb-2">
          <!-- CARD HEADER & CLICK TO OPEN DETAIL PANEL -->
          <div (click)="openDetailsPanel(item); selectLeadInCanvas(item)">
            <div class="card-header-top mb-2">
              <div>
                @if(item?.project || project || isOutboundLead(item)){
                <span class="project-pill-badge" [ngClass]="{
                  'badge-iic-lab': getLeadProjectBadge(item) === 'IIC-LAB',
                  'badge-v-retail': getLeadProjectBadge(item) === 'V-RETAIL',
                  'badge-v-estate': getLeadProjectBadge(item) === 'V-ESTATE',
                  'badge-outbound': getLeadProjectBadge(item) === 'OUTBOUND'
                }">{{ getLeadProjectBadge(item) }}</span>
                }
              </div>

              <div class="d-flex align-items-center">
                @if(item?.hasClosingPotential){
                <span class="closing-pool-badge-pill mr-1" title="In Closing Pool">🦄</span>
                }
                @if(item?.customerValue || item?.badge){
                <div class="badge-pill {{ getBadgeClass(item?.customerValue || item?.badge) }}">
                  {{ item.customerValue || item.badge }}
                </div>
                }
                <button type="button" class="btn btn-accordion-toggle ml-2" (click)="toggleAccordion(item, $event)">
                  <svg width="14" height="8" viewBox="0 0 14 8" [class.rotate-180]="expandedLeadId === item._id">
                    <path d="M1 1L7 7L13 1" stroke="#425166" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- LEAD IDENTITY (AVATAR + NAME) -->
            <div class="card-lead-identity mb-2">
              <div class="lead-avatar-box">
                <img [src]="item?.companyProfileImg || '/assets/leads/default-icon.png'" alt="Avatar" />
              </div>
              <div class="lead-name-box">
                @if (item?.companyName && item?.companyName !== '-' && item?.companyName !== item?.name) {
                <p class="lead-company-name mb-0">{{ item?.companyName }}</p>
                }
                <h5 class="lead-person-name mb-0">{{ item?.name || item?.companyName || "-" }}</h5>
              </div>
            </div>

            <!-- SUMMARY MIDDLE CARD (VISIBLE WHEN COLLAPSED) -->
            @if (expandedLeadId !== item._id) {
            <div class="card-summary-box mb-1">
              <div class="summary-assignee-col">
                <img class="assignee-avatar assigned-img" [src]="getAssignedByImg(item)" (error)="onImgError($event)"
                  alt="Assignee" />
                <div class="assignee-text-group">
                  <span class="summary-label">Assigned To</span>
                  <p class="summary-assignee-name" [innerHTML]="getAssignedToDisplay(item, true)"></p>
                </div>
              </div>

              <div class="summary-divider"></div>

              <div class="summary-meta-col">
                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Assigned On</span>
                    <p class="summary-value">{{ getAssignedOnDate(item?.assignedTo?.assignedOn) }}</p>
                  </div>
                </div>

                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Last Activity</span>
                    <p class="summary-value">{{ getAssignedOnDate(item?.updatedAt) }}</p>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>

          <!-- ACCORDION EXPANDED DETAILS -->
          @if(expandedLeadId === item._id){
          <div class="card-expanded-section mt-3 pt-2" (click)="openDetailsPanel(item); selectLeadInCanvas(item)">

            <!-- Section 1: Basic Information -->
            <div class="section-divider-header">
              <div class="section-header-left">
                <div class="section-icon-badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <span class="section-title-text">Basic Information</span>
              </div>
              <div class="section-header-line"></div>
            </div>

            <div class="basic-info-grid mb-3">
              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Name</span>
                  <p class="field-value">{{ item?.name || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Job Role</span>
                  <p class="field-value">{{ item?.designation || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Created</span>
                  <p class="field-value">{{ item?.createdAt | date : "MMMM d, yyyy" }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                    </path>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Next Follow Up</span>
                  <p class="field-value">{{ item?.followUpDate ? (item.followUpDate | date : "MMMM d, yyyy") : '-' }}
                  </p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Email</span>
                  <p class="field-value text-truncate">{{ getLeadEmail(item) || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                    </path>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Phone</span>
                  <p class="field-value">{{ getLeadPhone(item) }}</p>
                </div>
              </div>
            </div>

            <!-- Section 2: Assignment Details -->
            <div class="section-divider-header">
              <div class="section-header-left">
                <div class="section-icon-badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                  </svg>
                </div>
                <span class="section-title-text">Assignment Details</span>
              </div>
              <div class="section-header-line"></div>
            </div>

            <div class="card-summary-box expanded-assignment-box mt-2">
              <div class="summary-assignee-col">
                <img class="assignee-avatar assigned-img" [src]="getAssignedByImg(item)" (error)="onImgError($event)"
                  alt="Assignee" />
                <div class="assignee-text-group">
                  <span class="summary-label">Assigned To</span>
                  <p class="summary-assignee-name" [innerHTML]="getAssignedToDisplay(item, true)"></p>
                </div>
              </div>

              <div class="summary-divider"></div>

              <div class="summary-meta-col">
                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Assigned On</span>
                    <p class="summary-value">{{ getAssignedOnDate(item?.assignedTo?.assignedOn) }}</p>
                  </div>
                </div>

                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Last Activity</span>
                    <p class="summary-value">{{ getAssignedOnDate(item?.updatedAt) }}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
          }
        </div>

        }
      </div>
      }
    </div>
    <div class="scroll-hit-area"></div>
  </div>

  <!-- DETAILS PANEL -->
  @if (showDetailsPanel) {
  <div class="details-panel-backdrop pre-fade" (click)="closeDetailsPanel()">
    <div class="details-panel" (click)="onDetailsPanelClick($event)">
      <form class="lead-update-form" [formGroup]="leadForm" (ngSubmit)="updateLead()">
        <div class="details-header">
          <div class="details-header-left d-flex align-items-center">
            <button type="button" class="details-back-btn" (click)="closeDetailsPanel()">
              <svg xmlns="http://www.w3.org/2000/svg" width="2.2rem" height="2.2rem" viewBox="0 0 24 24">
                <path fill="#000"
                  d="M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42s1.02.39 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41l-6.58-6.6a.996.996 0 1 0-1.41 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1" />
              </svg>
            </button>
            <div class="canvas-logo d-flex align-items-center">
              <img [src]="logoPreview || 'assets/leads/default-icon.png'" alt="Logo" />
              @if (isLoadingLeadDetails) {
              <span class="spinner-border spinner-border-sm text-primary ml-2"
                title="Refreshing lead details..."></span>
              }
            </div>
          </div>

          <div class="details-header-actions d-flex align-items-center justify-content-end">
            @if (isLeadInClosingPool) {
            <span class="closing-pool-tag-info mr-2">
              <span class="unicorn-icon-text">🦄</span> Closing Pool
            </span>
            }
            <button type="button" class="btn-closing-pool" (click)="toggleClosingPool()"
              [class.in-pool]="isLeadInClosingPool" [disabled]="isUpdatingClosingPool">
              @if (isUpdatingClosingPool) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
              Updating...
              } @else if (isLeadInClosingPool) {
              <span class="unicorn-icon-text">🦄</span> Remove from Closing Pool
              } @else {
              <span class="unicorn-icon-text">🦄</span> Add to Closing Pool
              }
            </button>
            <button class="btn-save" type="submit" [disabled]="isUpdatingLead || !hasUnsavedChanges"
              [class.btn-disabled]="!hasUnsavedChanges">
              @if (isUpdatingLead) {
              <span class="spinner-border spinner-border-sm mr-2"></span>
              Saving...
              } @else {
              ✓ Save Changes
              }
            </button>
          </div>
        </div>

        <div class="details-body mt-2">
          <div class="detail-row">
            <label>Company Name</label><span class="colon">:</span>
            <input type="text" class="detail-input ml-2" formControlName="companyName"
              placeholder="Enter company name" />
          </div>
          <div class="detail-row">
            <label>Lead Name</label><span class="colon">:</span>
            <input type="text" class="detail-input ml-2" formControlName="leadName" placeholder="Enter lead name" />
          </div>
          <div class="detail-row">
            <label>Email</label><span class="colon">:</span>
            <input type="email" class="detail-input ml-2" formControlName="email" placeholder="Enter email" />
          </div>
          <div class="detail-row">
            <label>Phone no</label><span class="colon">:</span>
            <div class="d-flex flex-column">
              <input type="text" class="detail-input ml-2" formControlName="phoneNo" placeholder="Enter phone number" />

              @if (selectedLeadForDetails?.extractedRecordingUrl || selectedLead?.extractedRecordingUrl) {
              <div class="mt-2 w-100">
                <div class="d-flex align-items-center justify-content-between mb-1 px-1">
                  <span class="text-muted" style="font-size: 11.5px; font-weight: 500;margin-left: 8px;">IVR
                    Recording</span>
                  <span class="text-muted" style="font-size: 11.5px; font-weight: 600;">Total Duration: {{
                    formatDuration(audioDuration || selectedLead?.duration || selectedLeadForDetails?.duration)
                    }}</span>
                </div>
                <div class="custom-audio-player d-flex align-items-center">
                  <button type="button" class="audio-control-btn play-pause-btn"
                    (click)="togglePlayPause(ivrAudioPlayerPanel)" [title]="isPlayingAudio ? 'Pause' : 'Play'">
                    @if (isPlayingAudio) {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <rect x="6" y="4" width="4" height="16" rx="1"></rect>
                      <rect x="14" y="4" width="4" height="16" rx="1"></rect>
                    </svg>
                    } @else {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M8 5v14l11-7z"></path>
                    </svg>
                    }
                  </button>

                  <!-- Speed Pill Button RIGHT NEXT to Play button -->
                  <button type="button" class="audio-speed-pill-btn" (click)="toggleAudioSpeed(ivrAudioPlayerPanel)"
                    title="Click to cycle speed: 1x -> 1.5x -> 2x -> 3x">
                    {{ selectedAudioSpeed }}x
                  </button>

                  <!-- Time display -->
                  <span class="audio-time-text ml-2 mr-2">
                    {{ formatTime(currentAudioTime) }} / {{ formatTime(audioDuration || selectedLead?.duration ||
                    selectedLeadForDetails?.duration) }}
                  </span>

                  <!-- Seek slider -->
                  <div class="audio-progress-container flex-grow-1 mx-2">
                    <input type="range" class="audio-progress-slider" min="0"
                      [max]="audioDuration || selectedLead?.duration || selectedLeadForDetails?.duration || 100"
                      [value]="currentAudioTime" (input)="onAudioSeekInput($event)"
                      (change)="onAudioSeekChange($event, ivrAudioPlayerPanel)" />
                  </div>

                  <!-- Mute toggle button -->
                  <button type="button" class="audio-control-btn mute-btn" (click)="toggleMute(ivrAudioPlayerPanel)"
                    [title]="isAudioMuted ? 'Unmute' : 'Mute'">
                    @if (isAudioMuted) {
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                      <line x1="23" y1="9" x2="17" y2="15"></line>
                      <line x1="17" y1="9" x2="23" y2="15"></line>
                    </svg>
                    } @else {
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                      <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                    </svg>
                    }
                  </button>

                  <audio #ivrAudioPlayerPanel id="ivrRecordingPanel"
                    [src]="selectedLeadForDetails?.extractedRecordingUrl || selectedLead?.extractedRecordingUrl"
                    preload="metadata" style="display: none;" (timeupdate)="onAudioTimeUpdate(ivrAudioPlayerPanel)"
                    (play)="onAudioPlay($event)" (pause)="isPlayingAudio = false"
                    (ended)="isPlayingAudio = false; currentAudioTime = 0" (loadedmetadata)="onAudioLoaded($event)">
                  </audio>
                </div>
              </div>
              } @else if (isIvrLead(selectedLeadForDetails || selectedLead)) {
              <div class="mt-2 w-100">
                <div class="d-flex align-items-center justify-content-between mb-1 px-1">
                  <span class="text-muted" style="font-size: 11.5px; font-weight: 500;">IVR Recording</span>
                  @if (selectedLead?.duration || selectedLeadForDetails?.duration) {
                  <span class="text-muted" style="font-size: 11.5px; font-weight: 600;">Total Duration: {{
                    formatDuration(selectedLead?.duration || selectedLeadForDetails?.duration)
                    }}</span>
                  }
                </div>
                <p class="text-muted mb-0 small px-1" style="font-size: 12px;">
                  <i class="fas fa-exclamation-circle mr-1 text-warning"></i>
                  No recording available for this call.
                </p>
              </div>
              }
            </div>
          </div>

          <div class="detail-row">
            <label>Designation</label><span class="colon">:</span>
            <input type="text" class="detail-input" formControlName="designation" [readonly]="true" [disabled]="true" />
          </div>

          <div class="detail-row">
            <label>Created Date</label><span class="colon">:</span>
            <input type="text" class="detail-input created-at-input" [value]="selectedLead?.createdAt | date"
              [readonly]="true" [disabled]="true" />
          </div>

          <div class="detail-row" [formGroup]="followUpForm">
            <label>Next Follow Up</label>
            <span class="colon">:</span>

            <div class="followup-inline">
              <div class="d-flex align-items-center w-100">
                <!-- Date -->
                <input type="date" class="detail-input" formControlName="date" [readonly]="true" [disabled]="true"
                  placeholder="Select Date" />

                <!-- Time Dropdown -->
                <button type="button" class="btn dropdown-toggle dd-btn detail-input time-menu"
                  style="width: 141px!important; pointer-events: none;" [disabled]="true" [ngClass]="{
    'placeholder-grey': !followUpForm.value.time,
    'text-dark': followUpForm.value.time
  }">
                  {{ followUpForm.value.time || 'hh:mm' }}
                </button>


              </div>
              <!-- Type Dropdown -->
              <div class="dropdown custom-dd mt-3 w-100">
                <button type="button" class="btn dropdown-toggle dd-btn detail-input placeholder-grey w-100"
                  [disabled]="true" style="pointer-events: none;">
                  {{ followUpForm.value.type || "Select Type" }}
                </button>
              </div>
            </div>
          </div>

          <div class="detail-row">
            <label>Assigned To</label><span class="colon">:</span>
            <div class="dropdown custom-dd ml-2">
              <button type="button" class="btn dropdown-toggle dd-btn w-100" [disabled]="true"
                style="pointer-events: none;">
                {{ selectedLead?.assignedTo?.userName || '-' }}
              </button>
            </div>
          </div>

          <div class="detail-row">
            <label>Status</label><span class="colon">:</span>
            <div class="dropdown custom-dd ml-2">
              <button type="button" class="btn dropdown-toggle dd-btn w-100" [disabled]="true"
                style="pointer-events: none;">
                {{ selectedLead?.status || '-' }}
              </button>
            </div>
          </div>

          <!-- Lost Reason Field -->
          @if (showLostReason) {
          <div class="detail-row">
            <label>Lost Reason</label><span class="colon">:</span>
            <textarea class="detail-textarea notes-box ml-2" rows="3" formControlName="lossReason"
              placeholder="Please specify the reason for losing this lead" [readonly]="true" [disabled]="true">
            </textarea>
          </div>
          }
          <div class="detail-row">
            <label>Source</label><span class="colon">:</span>
            <textarea class="detail-textarea notes-box ml-2" rows="2" style="height: 42px"
              [value]="selectedLead?.source ? selectedLead?.source : '-'" [readonly]="true" [disabled]="true">
            </textarea>
          </div>

          @if (selectedLead?.source?.toLowerCase() === 'whatsapp') {
          <div class="detail-row align-items-start">
            <label style="margin-top: 6px;">WhatsApp Messages</label><span class="colon"
              style="margin-top: 6px;">:</span>
            <div class="whatsapp-messages-box ml-2">
              <app-whatsapp-messages-card [phoneNumber]="selectedLead?.phoneNo"></app-whatsapp-messages-card>
            </div>
          </div>
          } @else {
          <div class="detail-row">
            <label>User Message</label><span class="colon">:</span>
            <textarea class="detail-textarea notes-box user-msg ml-2" rows="5"
              [value]="getLeadDisplayMessage(selectedLead)" [readonly]="true" [disabled]="true">
            </textarea>
          </div>
          }

          <!-- Badge Field -->
          <div class="detail-row">
            <label>Badge</label><span class="colon">:</span>
            @if (isAdmin) {
            <div class="dropdown custom-dd ml-2 badge-dd-container badge-dd badge-dropdown"
              [class.show]="badgeDropdownOpen" style="width: 275px !important;">
              <button type="button"
                class="btn dropdown-toggle dd-btn w-100 d-flex align-items-center justify-content-between"
                [class.badge-dd-active]="badgeDropdownOpen" (click)="toggleBadgeDropdown()">
                @if (selectedBadgeDetails) {
                <span class="badge-pill {{ selectedBadgeDetails.class }}">
                  {{ selectedBadgeDetails.label }}
                </span>
                } @else {
                <span style="margin: 0; color: #aaa">Select Badge</span>
                }

                @if (badgeDropdownOpen) {
                <span class="close-badge-dd ml-2" (click)="$event.stopPropagation(); badgeDropdownOpen = false"
                  title="Close">
                  ✕
                </span>
                } @else {
                <span class="dropdown-caret-icon ml-2">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 10l5 5 5-5H7z" fill="#888888" />
                  </svg>
                </span>
                }
              </button>

              <div class="dropdown-menu badge-items w-100" [class.show]="badgeDropdownOpen"
                style="width: 275px !important;">
                @for (badge of badgeOptions; track badge.value) {
                <div class="dropdown-item d-flex justify-content-between align-items-center"
                  (click)="selectBadgeDetails(badge.value)">
                  <span class="badge-pill {{ badge.class }}">
                    {{ badge.label }}
                  </span>
                  <input type="radio" class="badge-radio" [checked]="selectedBadgeDetails?.value === badge.value" />
                </div>
                }
              </div>
            </div>
            } @else {
            <div class="ml-2 d-flex align-items-center" style="height: 42px;">
              @if (selectedLead?.customerValue || selectedLead?.badge) {
              <span class="badge-pill {{ getBadgeClass(selectedLead?.customerValue || selectedLead?.badge) }}">
                {{ selectedLead?.customerValue || selectedLead?.badge }}
              </span>
              } @else {
              <span style="color: #aaa">-</span>
              }
            </div>
            }
          </div>

          <div class="detail-row">
            <label>Admin Notes</label><span class="colon">:</span>
            @if (isAdmin) {
            <textarea class="detail-textarea notes-box admin-notes ml-2" rows="5" formControlName="adminNotes"
              placeholder="Enter admin notes...">
            </textarea>
            } @else {
            <textarea class="detail-textarea notes-box admin-notes ml-2" rows="5" [value]="
                selectedLead?.adminNotes || selectedLead?.description || '-'
              " disabled readonly>
            </textarea>
            }
          </div>
          <hr class="canvas-divider" />

          <!-- INFINITE EDITOR -->
          <div class="notion-editor-container">

            <!-- ASSISTANT SALES FOLLOW-UP TASK ACTION BOX -->
            @if (canShowAssistantTaskActionBox) {
            <div class="assistant-task-action-box my-3 p-3">
              <!-- Top Row: Follow up Reminder Header & Badge -->
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center" style="gap: 8px;">
                  <div class="d-flex align-items-center justify-content-center reminder-task-icon-wrapper">
                    <i class="fas fa-bell" style="font-size: 13px;"></i>
                  </div>
                  <span class="reminder-task-title">
                    Follow up Reminder
                  </span>
                </div>
                <span class="badge d-inline-flex align-items-center"
                  [style.background]="assistantTaskReminderDueAt ? '#dcfce7' : '#fee2e2'"
                  [style.color]="assistantTaskReminderDueAt ? '#15803d' : '#b91c1c'"
                  [style.border]="assistantTaskReminderDueAt ? '1px solid #bbf7d0' : '1px solid #fecaca'"
                  style="font-size: 12px; font-weight: 500; padding: 4px 10px; border-radius: 12px; gap: 5px;">
                  <i [class]="assistantTaskReminderDueAt ? 'fas fa-check' : 'fas fa-clock'"
                    style="font-size: 11px;"></i>
                  {{ assistantTaskReminderDueAt ? 'Reminder date selected' : 'Date required to complete' }}
                </span>
              </div>

              <!-- Reminder Date Input (at top) -->
              <div class="d-flex align-items-center mb-3" style="gap: 12px;">
                <div class="position-relative flex-grow-1" style="max-width: 280px;">
                  <input type="date" class="form-control reminder-due-input" [(ngModel)]="assistantTaskReminderDueAt"
                    [ngModelOptions]="{standalone: true}" [min]="todayDate" placeholder="Select reminder date" />
                  @if (assistantTaskReminderDueAt) {
                  <button type="button" class="clear-btn" (click)="assistantTaskReminderDueAt = ''" title="Clear date"
                    style="right: 32px;">
                    <i class="fas fa-times"></i>
                  </button>
                  }
                </div>
              </div>

              <!-- Task Notes Section -->
              <div>
                <!-- Task Notes Label -->
                <label class="d-block mb-1 assistant-task-label">
                  Follow up Task Notes
                </label>
                <!-- Task Notes Textarea -->
                <textarea class="form-control mb-3 assistant-task-textarea" placeholder="Enter task notes..."
                  [(ngModel)]="assistantTaskNote" [ngModelOptions]="{standalone: true}" rows="3"></textarea>

                <!-- Right Side Action Buttons -->
                <div class="d-flex align-items-center justify-content-end">
                  <!-- Mark as Done Button -->
                  <button type="button" class="btn btn-success d-inline-flex align-items-center justify-content-center"
                    (click)="markAssistantTaskDone()"
                    [disabled]="!assistantTaskNote?.trim() || !assistantTaskReminderDueAt || isCompletingTask"
                    style="height: 38px; padding: 0 18px; font-size: 13px; font-weight: 600; border-radius: 6px;">
                    @if (isCompletingTask) {
                    <span class="spinner-border spinner-border-sm mr-1"></span>
                    }
                    Mark as Done
                  </button>
                </div>
              </div>
            </div>
            }

            <!-- DISPOSITION STATUS -->
            <div class="disposition-container">

              <!-- DISPOSITION & ACTIVITY LIST  -->
              @if (formattedDispositions.length) {
              <div class="disposition-flow mt-3">

                @for (item of formattedDispositions; track item._id || item.id || $index; let i = $index) {

                <!-- FOLLOW-UP TASK EVENT -->
                @if (item.isFollowUpTaskEvent) {
                <div class="disposition-item my-4">
                  <p class="disposition-index" style="font-weight: 600; color: #64748b;">{{ item.seqNo || (i + 1) }}.
                  </p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="d-flex align-items-center" style="gap: 6px;">
                      <img src="/assets/leads/follow-up-task.svg" class="status-icon" alt="Followup Task" width="24"
                        height="24" style="flex-shrink: 0;" />
                      <span class="user-name" style="color: #334155; font-size: 15px; font-weight: 700;">Followup
                        Task</span>
                    </div>
                    <div class="date-text" style="font-size: 12px; color: #64748b; margin-top: 2px; margin-left: 3px;">
                      {{ (item.timestamp || item.updatedAt || item.createdAt) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only d-flex flex-column align-items-start"
                    style="gap: 6px;">
                    @if (item.logType === 'completed') {
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px;">
                      <!-- ASSISTANT SALES USER NAME -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assigneeProfileImg) {
                        <img [src]="item.assigneeProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assigneeProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.assigneeName }}
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- DONE TAG -->
                      <span class="status-pill done-status d-flex align-items-center"
                        style="font-weight: 600; color: #166534; background: #dcfce7; border: 1px solid #bbf7d0; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        <i class="fas fa-check-circle" style="color: #16a34a; font-size: 12px;"></i>
                        Done
                      </span>
                    </div>

                    @if (item.note) {
                    <div class="task-desc-note mt-1">
                      <span style="font-weight: 600!important; color: #475569;">Note :</span> {{ item.note }}
                    </div>
                    }
                    } @else if (item.logType === 'updated') {
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px;">
                      <!-- ASSISTANT SALES USER NAME -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assigneeProfileImg) {
                        <img [src]="item.assigneeProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assigneeProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.assigneeName }}
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- UPDATED TAG -->
                      <span class="status-pill update-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e40af; background: #e0f2fe; border: 1px solid #bae6fd; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        <i class="fas fa-sync-alt" style="color: #2563eb; font-size: 11px;"></i>
                        Updated
                      </span>
                    </div>

                    @if (item.note) {
                    <div class="task-desc-note mt-1">
                      <span style="font-weight: 600!important; color: #475569;">Note :</span> {{ item.note }}
                    </div>
                    }
                    } @else {
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px;">
                      <!-- ASSIGNED BY -->
                      <span class="status-pill prev-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #e2e8f0; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assignedByProfileImg) {
                        <img [src]="item.assignedByProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assignedByProfileImg = null" />
                        } @else {
                        <i class="fas fa-user-circle" style="color: #64748b; font-size: 11px;"></i>
                        }
                        {{ item.assignedByName }}
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- ASSIGNEE -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assigneeProfileImg) {
                        <img [src]="item.assigneeProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assigneeProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.assigneeName }}
                      </span>
                    </div>

                    @if (item.note) {
                    <div class="task-desc-note mt-1">
                      <span style="font-weight: 600!important; color: #475569;">Task :</span> {{ item.note }}
                    </div>
                    }
                    }
                  </div>
                </div>
                }

                <!-- LEAD REASSIGNED EVENT -->
                @else if (item.isLeadReassignedEvent) {
                <div class="disposition-item my-4">
                  <p class="disposition-index" style="font-weight: 600; color: #64748b;">{{ item.seqNo || (i + 1) }}.
                  </p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name" style="color: #334155; font-size: 15px; font-weight: 700;">
                      {{ item.reassignedByName || 'System' }}
                    </div>
                    <div class="date-text" style="font-size: 12px; color: #64748b; margin-top: 2px;">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only d-flex flex-column align-items-start"
                    style="gap: 6px;">
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px; margin-top: 6px;">
                      <!-- REASSIGNED BY -->
                      <span class="status-pill prev-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #e2e8f0; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.reassignedByProfileImg) {
                        <img [src]="item.reassignedByProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.reassignedByProfileImg = null" />
                        } @else {
                        <i class="fas fa-user-circle" style="color: #64748b; font-size: 11px;"></i>
                        }
                        {{ item.reassignedByName || 'System' }}
                      </span>

                      <!-- ARROW LINE WITH MESSAGE ABOVE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-message-label">
                          <b class="event-prefix" style="font-weight: 700; color: #0f172a;">Reassigned :</b> {{
                          item.reassignedByName }} reassigned lead to {{ item.reassignedToName }}
                        </span>
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- REASSIGNED TO -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.reassignedToProfileImg) {
                        <img [src]="item.reassignedToProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.reassignedToProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.reassignedToName }}
                      </span>
                    </div>
                  </div>
                </div>
                }

                <!-- LEAD FOLLOW UP ASSIGNED EVENT -->
                @else if (item.isLeadFollowUpAssignedEvent) {
                <div class="disposition-item my-4">
                  <p class="disposition-index" style="font-weight: 600; color: #64748b;">{{ item.seqNo || (i + 1) }}.
                  </p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name" style="color: #334155; font-size: 15px; font-weight: 700;">
                      {{ item.assignedByName || 'System' }}
                    </div>
                    <div class="date-text" style="font-size: 12px; color: #64748b; margin-top: 2px;">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only d-flex flex-column align-items-start"
                    style="gap: 6px;">
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px; margin-top: 6px;">
                      <!-- ASSIGNED BY -->
                      <span class="status-pill prev-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #e2e8f0; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assignedByProfileImg) {
                        <img [src]="item.assignedByProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assignedByProfileImg = null" />
                        } @else {
                        <i class="fas fa-user-circle" style="color: #64748b; font-size: 11px;"></i>
                        }
                        {{ item.assignedByName || 'System' }}
                      </span>

                      <!-- ARROW LINE WITH MESSAGE ABOVE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-message-label">
                          <b class="event-prefix" style="font-weight: 700; color: #0f172a;">Follow-up Assigned :</b> {{
                          item.assignedByName }} assigned follow-up to {{ item.assignedToName }}
                        </span>
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- ASSIGNED TO -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assignedToProfileImg) {
                        <img [src]="item.assignedToProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assignedToProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.assignedToName }}
                      </span>
                    </div>

                    @if (item.note) {
                    <div class="task-desc-note mt-1">
                      <span style="font-weight: 600!important; color: #475569;">Note :</span> {{ item.note }}
                    </div>
                    }
                  </div>
                </div>
                }

                <!-- LEAD ASSIGNED EVENT -->
                @else if (item.isLeadAssignedEvent) {
                <div class="disposition-item my-4">
                  <p class="disposition-index" style="font-weight: 600; color: #64748b;">{{ item.seqNo || (i + 1) }}.
                  </p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name" style="color: #334155; font-size: 15px; font-weight: 700;">
                      {{ item.assignedByName || 'System' }}
                    </div>
                    <div class="date-text" style="font-size: 12px; color: #64748b; margin-top: 2px;">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only d-flex flex-column align-items-start"
                    style="gap: 6px;">
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px; margin-top: 6px;">
                      <!-- ASSIGNED BY -->
                      <span class="status-pill prev-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #e2e8f0; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assignedByProfileImg) {
                        <img [src]="item.assignedByProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assignedByProfileImg = null" />
                        } @else {
                        <i class="fas fa-user-circle" style="color: #64748b; font-size: 11px;"></i>
                        }
                        {{ item.assignedByName || 'System' }}
                      </span>

                      <!-- ARROW LINE WITH MESSAGE ABOVE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-message-label">
                          <b class="event-prefix" style="font-weight: 700; color: #0f172a;">Lead Assigned :</b> {{
                          item.assignedByName }} assigned lead to {{ item.assignedToName }}
                        </span>
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- ASSIGNED TO -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assignedToProfileImg) {
                        <img [src]="item.assignedToProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assignedToProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.assignedToName }}
                      </span>
                    </div>
                  </div>
                </div>
                }

                <!-- SYSTEM CLOSING POOL UPDATE -->
                @else if (
                item.isClosingPoolEvent ||
                (item.type === 'System' && (item.event === 'Closing Pool Update' || item.hasClosingPotential !==
                undefined))
                ) {
                <div class="disposition-item my-3">

                  <!-- INDEX -->
                  <p class="disposition-index">{{ item.seqNo || (i + 1) }}.</p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name" style="color: grey;font-size: 18px;">System</div>

                    <div class="date-text">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM, hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only">
                    <div class="status-arrow-wrapper">

                      @if (isClosingPoolAdded(item)) {
                      <!-- PREVIOUS STAGE STATUS -->
                      <span class="status-pill prev-status d-flex align-items-center">
                        @if(getStatusIcon(getLeadStageStatus(item))){
                        <img [src]="getStatusIcon(getLeadStageStatus(item))" class="status-icon mr-1" alt="prev status"
                          width="30" />
                        }
                        {{ getLeadStageStatus(item) }}
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line">
                        <span class="arrow-head">▶</span>
                      </span>

                      <!-- ADDED TO CLOSING POOL -->
                      <span class="status-pill current-status d-flex align-items-center closing-pool-added-pill">
                        <span class="mr-1">🦄</span>
                        Closing Pool
                      </span>
                      } @else {
                      <!-- FROM CLOSING POOL -->
                      <span class="status-pill prev-status d-flex align-items-center closing-pool-removed-pill">
                        <span class="mr-1">🦄</span>
                        Closing Pool
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line">
                        <span class="arrow-head">▶</span>
                      </span>

                      <!-- TO STAGE STATUS -->
                      <span class="status-pill current-status d-flex align-items-center">
                        @if(getStatusIcon(getLeadStageStatus(item))){
                        <img [src]="getStatusIcon(getLeadStageStatus(item))" class="status-icon mr-1"
                          alt="current status" width="30" />
                        }
                        {{ getLeadStageStatus(item) }}
                      </span>
                      }

                    </div>
                  </div>

                </div>
                }

                <!-- SYSTEM STATUS CHANGE / STATUS UPDATE -->
                @else if (
                item.isStatusUpdateEvent ||
                (item.type === 'System' && item.status && item.prevStatus !== item.status)
                ) {
                <div class="disposition-item my-3">

                  <!-- INDEX -->
                  <p class="disposition-index">{{ item.seqNo || (i + 1) }}.</p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name" style="color: grey;font-size: 18px;">System</div>

                    <div class="date-text">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM, hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only">
                    <div class="status-arrow-wrapper">

                      <!-- PREVIOUS STATUS -->
                      <span class="status-pill prev-status d-flex align-items-center">
                        @if(getStatusIcon(item.prevStatus)){
                        <img [src]="getStatusIcon(item.prevStatus)" class="status-icon mr-1" alt="prev status"
                          width="30" />
                        }
                        {{ item.prevStatus || '-' }}
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line">
                        <span class="arrow-head">▶</span>
                      </span>

                      <!-- CURRENT STATUS -->
                      <span class="status-pill current-status d-flex align-items-center">
                        @if(getStatusIcon(item.status)){
                        <img [src]="getStatusIcon(item.status)" class="status-icon mr-1" alt="current status"
                          width="30" />
                        }
                        {{ item.status }}
                      </span>

                    </div>
                  </div>

                </div>
                }

                <!-- USER NOTE / GENERAL DISPOSITION -->
                @else if (item.note) {
                <div class="disposition-item my-3">
                  <p class="disposition-index"> {{ item.seqNo || (i + 1) }}. </p>
                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name">
                      {{ item.userName || '-' }}
                    </div>

                    @if (item.status) {
                    <div class="status-text d-flex align-items-center">
                      @if (getStatusIcon(item.status)) {
                      <img [src]="getStatusIcon(item.status)" class="status-icon mr-1" alt="status" width="25" />
                      }
                      <p class="mb-0">{{ item.status }}</p>
                    </div>
                    }

                    <div class="date-text">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM, hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-right">
                    <div class="disposition-note">
                      <p class="note-placeholder mb-0">Note:</p>
                      {{ item.note }}
                    </div>
                  </div>

                </div>
                }


                }

              </div>
              }


            </div>
            @if (dispositions.length) {
            <hr class="disposition-divider" />
            }

            <div class="editor-blocks">
              @for (block of editorBlocks; track block.id; let i = $index) {

              <!-- TEXT BLOCK -->
              @if (block.type === 'text') {
              <div class="editor-block" [attr.data-block-id]="block.id">
                <textarea #editorTextarea class="editor-textarea" [value]="block.value"
                  (input)="onTextBlockInput($event, i)" [attr.data-block-id]="block.id"
                  [placeholder]="getPlaceholderForBlock(block, i)" readonly>
                </textarea>
                @if(block.type === 'text' && block.value && block.value.length > 120){
                <button class="expand-btn" type="button" (click)="expandTextBlock(i)">
                  {{ expandedTextBlocks[i] ? 'show Less' : 'show More' }}
                </button>
                }
              </div>
              }

              <!-- FILE BLOCK -->
              @if (block.type === 'file') {
              <div class="editor-file-block">
                <!-- UPLOAD PROGRESS WRAPPER (VISIBLE WHILE UPLOADING) -->
                @if (block.uploading) {
                <div class="upload-progress-container">
                  <div class="upload-progress-bar">
                    <div class="upload-progress-fill" [style.width.%]="block.progress"></div>
                  </div>

                  <span class="upload-progress-text">
                    Uploading {{ block.progress }}%
                  </span>
                </div>
                }

                <!-- IMAGE PREVIEW -->
                @if (['jpg','jpeg','png','gif','webp'].includes(block.extension
                || '') && block.url) {
                <img class="preview-img" [src]="block.url" alt="image preview" (click)="openFullscreen(block)" />
                }

                <!-- VIDEO PREVIEW -->
                @if (['mp4','mov','webm','mkv'].includes(block.extension || '')
                && block.url) {
                <video class="preview-video" [poster]="block.thumbnailUrl" [src]="block.url" controls preload="metadata"
                  (click)="openFullscreen(block)"></video>

                }

                <!-- DOC / PDF / OTHER FILES -->
                @if
                (!['jpg','jpeg','png','gif','webp','mp4','mov','webm','mkv'].includes(block.extension
                || '')) {
                <div class="file-doc-block d-flex align-items-center gap-3" (click)="openFullscreen(block)">
                  <img class="doc-icon" src="/assets/leads/document-files-icon.png" width="50" height="50"
                    alt="Document" />
                  <div class="doc-meta ml-2">
                    <p class="file-doc-name mb-1">{{ block.fileName }}</p>
                    <p class="file-doc-date mb-0">
                      {{ block.uploadedAt | date : "dd MMM yyyy" }} •
                      {{ block.uploadedAt | date : "hh:mm a" }}
                    </p>
                  </div>
                </div>
                }
              </div>
              } }

              <div class="editor-bottom-space"></div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  }
  <!-- FULLSCREEN PREVIEW MODAL -->
  @if (fullscreenPreview) {
  <div class="fs-backdrop" (click)="closeFullscreen()"></div>

  <div class="fs-container">
    <!-- CLOSE BUTTON -->
    <div class="d-flex align-items-center">
      <button class="fs-close" (click)="closeFullscreen()">✕</button>
      <svg (click)="downloadFile(fullscreenPreview)" class="fs-download-btn mr-2" xmlns="http://www.w3.org/2000/svg"
        width="2.5rem" height="2.5rem" viewBox="0 0 24 24">
        <path fill="#fff"
          d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z" />
      </svg>
    </div>
    <!-- IMAGE PREVIEW -->
    @if (fullscreenPreview.type === 'image') {
    <img class="fs-image" [src]="fullscreenPreview.url" />
    }

    <!-- VIDEO PREVIEW -->
    @if (fullscreenPreview.type === 'video') {
    <video class="fs-video" [src]="fullscreenPreview.url" controls autoplay></video>
    }

    <!-- DOCUMENT PREVIEW -->
    @if (fullscreenPreview.type === 'document') {
    <div class="fs-doc-preview">
      <img src="/assets/leads/document-files-icon.png" width="80" />
      <p class="file-name-text">{{ fullscreenPreview.fileName }}</p>
    </div>
    }
  </div>
  }
</div>
}

<!-- ADMIN ASSIGN MODAL (REDESIGNED) -->
<div class="modal fade iic-lead-banner redesigned-lead-modal" #iicContactLead id="contactLeadDetail" tabindex="-1"
  role="dialog" aria-labelledby="contactLeadDetailModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <!-- HEADER -->
      <div class="modal-header">
        <div class="header-title-box">
          <div class="header-icon-badge">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
            </svg>
          </div>
          <h5 class="header-title-text" id="exampleModalLongTitle">
            Lead Details
          </h5>
          @if (singleLead?.hasClosingPotential || selectedLead?.hasClosingPotential) {
          <span class="closing-pool-tag-info ml-2">
            <span class="unicorn-icon-text">🦄</span> Closing Pool
          </span>
          }
        </div>

        <div class="header-actions">
          @if (isOutboundLead(singleLead) && isLeadUnassigned(singleLead)) {
          <button type="button" class="btn copy-clipboard-btn" data-dismiss="modal"
            (click)="openEditOutboundLeadModal(singleLead)" title="Edit lead details">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
            <span>Edit</span>
          </button>
          }

          <div class="copy-btn-wrapper" style="position: relative; display: inline-flex; align-items: center;">
            <button type="button" class="btn copy-clipboard-btn" (click)="copyLeadDetails()" title="Copy details">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
              <span class="d-none d-sm-inline">Copy to clipboard</span>
              <span class="d-inline d-sm-none">Copy</span>
            </button>
            @if (showCopyTooltip) {
            <span class="copy-tooltip">Copied!</span>
            }
          </div>

          <button type="button" class="btn modal-close-sq-btn" data-dismiss="modal" aria-label="Close"
            (click)="resetModalState()">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>

      <!-- BODY GRID -->
      <div class="modal-body">
        <div class="lead-modal-grid">

          <!-- LEFT COLUMN -->
          <div class="left-col-wrapper">

            <!-- CARD 1: Lead Information -->
            <div class="modal-section-card">
              <div class="section-card-header">
                <div class="section-card-header-left">
                  <div class="section-card-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <h6 class="section-card-title">Lead Information</h6>
                </div>
              </div>

              <div class="info-field-list">
                <div class="info-field-row">
                  <div class="info-field-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    <span>Name</span>
                  </div>
                  <div class="info-field-value">
                    {{ (singleLead?.name && singleLead?.name !== getAgentName(singleLead)) ? singleLead?.name : "-" }}
                  </div>
                </div>

                <div class="info-field-row">
                  <div class="info-field-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    <span>Email</span>
                  </div>
                  <div class="info-field-value">
                    {{ getLeadEmail(singleLead) }}
                  </div>
                </div>

                <div class="info-field-row">
                  <div class="info-field-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path
                        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                      </path>
                    </svg>
                    <span>Phone</span>
                  </div>
                  <div class="info-field-value">
                    {{ getLeadPhone(singleLead) }}
                  </div>
                </div>

                <div class="info-field-row">
                  <div class="info-field-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <span>Date</span>
                  </div>
                  <div class="info-field-value">
                    <div>{{ singleLead?.createdAt ? (singleLead?.createdAt | date : "dd MMM yyyy") : "-" }}</div>
                    @if (singleLead?.createdAt) {
                    <div class="text-muted small" style="font-size: 11px; margin-top: 1px; font-weight: 400;">
                      ({{ singleLead?.createdAt | date : "hh:mm a" }})
                    </div>
                    }
                  </div>
                </div>

                @if (hasIvrDetails(singleLead)) {
                <div class="info-field-row pt-2 border-top">
                  <div class="info-field-left">
                    <span>Caller ID</span>
                  </div>
                  <div class="info-field-value">
                    {{ (singleLead?.name && singleLead?.name !== getAgentName(singleLead)) ? singleLead?.name :
                    (singleLead?.callerId || "-") }}
                  </div>
                </div>

                <div class="info-field-row">
                  <div class="info-field-left">
                    <span>Caller No</span>
                  </div>
                  <div class="info-field-value">
                    {{ singleLead?.callerNo || singleLead?.calledNo || "-" }}
                  </div>
                </div>

                <div class="info-field-row">
                  <div class="info-field-left">
                    <span>Direction</span>
                  </div>
                  <div class="info-field-value">
                    {{ singleLead?.callType === 'Notanswered' ? 'Not answered' : (singleLead?.direction ||
                    singleLead?.callType || "-") }}
                  </div>
                </div>

                <div class="info-field-row">
                  <div class="info-field-left">
                    <span>Duration</span>
                  </div>
                  <div class="info-field-value">
                    {{ singleLead?.duration ? singleLead?.duration : "-" }}
                  </div>
                </div>
                }
              </div>
            </div>

            <!-- CARD 2: Tags & Source -->
            <div class="modal-section-card">
              <div class="section-card-header">
                <div class="section-card-header-left">
                  <div class="section-card-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                      <line x1="7" y1="7" x2="7.01" y2="7"></line>
                    </svg>
                  </div>
                  <h6 class="section-card-title">Tags & Source</h6>
                </div>
              </div>

              <div class="info-field-list">
                <div class="info-field-row">
                  <div class="info-field-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <span>Status</span>
                  </div>
                  <div class="info-field-value">
                    <span class="status-pill-badge">
                      <span class="status-dot"></span>
                      {{ singleLead?.status || 'Not Started' }}
                    </span>
                  </div>
                </div>

                @if (singleLead?.deal) {
                <div class="info-field-row">
                  <div class="info-field-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <rect x="2" y="7" width="20" height="14" rx="2"></rect>
                      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"></path>
                    </svg>
                    <span>Deal</span>
                  </div>
                  <div class="info-field-value">
                    <span class="deal-tag" [class.lost]="singleLead.deal.status === 'cancelled'"
                      [class.won]="singleLead.deal.status !== 'pipeline' && singleLead.deal.status !== 'cancelled'">
                      {{ singleLead.deal.status === 'pipeline' ? 'Pipeline deal' : (singleLead.deal.status ===
                      'cancelled' ? 'Deal lost' : 'Deal won') }}
                    </span>
                    <span class="deal-line">{{ singleLead.deal.name }}@if (singleLead.deal.amount) { · {{
                      singleLead.deal.currency || 'INR' }} {{ singleLead.deal.amount.toLocaleString('en-IN') }} }@if
                      (singleLead.deal.status === 'pipeline' && singleLead.deal.expectedCloseOn) { · expected close {{
                      singleLead.deal.expectedCloseOn }} }</span>
                  </div>
                </div>
                }

                <div class="info-field-row">
                  <div class="info-field-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polygon
                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                      </polygon>
                    </svg>
                    <span>Badge</span>
                  </div>
                  <div class="info-field-value">
                    <div class="dropdown badge-dropdown d-inline-block">
                      <button class="badge-select-pill-btn dropdown-toggle" type="button" id="modal-badge-button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        @if (selectedBadge[0]) {
                        <span class="badge-pill {{ selectedBadge[0].class }}" style="margin: 0;">
                          {{ selectedBadge[0].label }}
                        </span>
                        } @else {
                        <span class="badge-select-placeholder">Select</span>
                        }
                        <svg class="dropdown-arrow-icon ml-1" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2.5">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </button>
                      <div class="dropdown-menu badge-items" style="border-radius: 12px !important">
                        @for (badge of badgeOptions; track badge.value) {
                        <div class="dropdown-item d-flex justify-content-between align-items-center"
                          (click)="selectBadge(badge.value, 0, singleLead._id)">
                          <span class="badge-pill {{ badge.class }}">
                            {{ badge.label }}
                          </span>
                          <input type="radio" class="badge-radio" [checked]="selectedBadge[0]?.value === badge.value" />
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div class="info-field-row">
                  <div class="info-field-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 15h-2v-6h2zm0-8h-2V7h2z" />
                    </svg>
                    <span>Source</span>
                  </div>
                  <div class="info-field-value">
                    <span class="source-pill-badge">
                      @if (singleLead?.source?.toLowerCase() === 'whatsapp') {
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                        <path
                          d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981z" />
                      </svg>
                      }
                      {{ singleLead?.source || '-' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- CARD 3: Quick Actions (Only rendered if actions exist) -->
            @if (hasQuickActions(singleLead)) {
            <div class="modal-section-card">
              <div class="section-card-header">
                <div class="section-card-header-left">
                  <div class="section-card-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <h6 class="section-card-title">Quick Actions</h6>
                </div>
              </div>

              <div class="quick-actions-wrapper">
                @if (canShiftToIIC(singleLead)) {
                <button type="button" class="btn btn-move-iic" data-dismiss="modal"
                  (click)="shiftToIICLeads(singleLead._id)">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="17 1 21 5 17 9"></polyline>
                    <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                    <polyline points="7 23 3 19 7 15"></polyline>
                    <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                  </svg>
                  Move to IIC Leads
                </button>
                }

                @if (isLeadUnassigned(singleLead) || singleLead?.isQualified === false || singleLead?.status ===
                'Unqualified') {
                <button type="button" class="btn btn-unqualified-toggle" data-dismiss="modal"
                  (click)="toggleLeadQualification(singleLead)">
                  @if (singleLead?.isQualified === false || singleLead?.status === 'Unqualified') {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                  Qualified
                  } @else {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
                  </svg>
                  Unqualified
                  }
                </button>
                }
              </div>
            </div>
            }

          </div>

          <!-- RIGHT COLUMN -->
          <div class="right-col-wrapper">

            <!-- TOP ROW: Assign To + Message / Activity -->
            <div class="right-top-grid">

              <!-- ASSIGN TO CARD -->
              <div class="modal-section-card assign-to-card">
                <div class="section-card-header">
                  <div class="section-card-header-left">
                    <div class="section-card-icon">
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="8.5" cy="7" r="4"></circle>
                        <line x1="20" y1="8" x2="20" y2="14"></line>
                        <line x1="23" y1="11" x2="17" y2="11"></line>
                      </svg>
                    </div>
                    <h6 class="section-card-title">Assign To</h6>
                  </div>
                </div>

                <div class="assign-users-container">
                  @for (user of salesUsers; track user._id || user.userName) {
                  <div class="assign-user-radio-box"
                    [class.active]="selectedAssignee ? (selectedAssignee._id === user._id || selectedAssignee.userName === user.userName) : (singleLead?.assignedToString === user.userName || singleLead?.followUpAssignedTo?.userName === user.userName)"
                    (click)="onAssigneeSelect(user)">
                    <div class="assign-user-info">
                      <img class="assign-user-avatar" [src]="user.profileImg || 'assets/default-user.svg'"
                        alt="avatar" />
                      <div>
                        <p class="assign-user-name">{{ user.userName }}</p>
                      </div>
                    </div>

                    <div class="custom-radio-circle">
                      <div class="custom-radio-circle-inner"></div>
                    </div>
                  </div>
                  }
                </div>
              </div>

              <!-- MESSAGE / ACTIVITY CARD -->
              <div class="modal-section-card message-activity-card">
                <div class="section-card-header">
                  <div class="section-card-header-left">
                    <div class="section-card-icon">
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                      </svg>
                    </div>
                    <h6 class="section-card-title">Message / Activity</h6>
                  </div>

                  @if (singleLead?.source?.toLowerCase() === 'whatsapp') {
                  <button type="button" class="btn view-detail-btn" (click)="viewWhatsAppDetail(singleLead)">
                    <span>View in Detail</span>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                      <polyline points="15 3 21 3 21 9"></polyline>
                      <line x1="10" y1="14" x2="21" y2="3"></line>
                    </svg>
                  </button>
                  }
                </div>

                <div class="activity-box-inner">
                  @if (singleLead?.source?.toLowerCase() === 'whatsapp') {
                  <app-whatsapp-messages-card #waCard [phoneNumber]="singleLead?.phoneNo"
                    (viewDetail)="viewWhatsAppDetail(singleLead)"></app-whatsapp-messages-card>
                  } @else {
                  <div class="h-100 d-flex flex-column">
                    <!-- <div class="activity-box-header">
                        <span class="activity-channel-title">Activity Note</span>
                        <span class="activity-timestamp">{{ singleLead?.createdAt | date : "dd MMM yyyy, hh:mm a"
                          }}</span>
                      </div> -->
                    @if (isEmailLead(singleLead) && singleLead?.subject) {
                    <div class="email-lead-subject-row mb-2">
                      <span class="font-weight-bold text-dark" style="font-size: 13.5px;">Subject : </span>
                      <span class="text-dark font-weight-500" style="font-size: 13.5px; word-break: break-word;">{{
                        singleLead?.subject }}</span>
                    </div>
                    }
                    <p class="message-text flex-grow-1 mb-0 text-muted"
                      style="font-size: 13.5px; white-space: pre-line; word-break: break-word;">
                      {{ getMessageWithDemoDate(singleLead) }}
                    </p>
                  </div>
                  }

                  @if (singleLead?.extractedRecordingUrl) {
                  <div class="pt-3 border-top mt-2" style="width: 100%;">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <label class="mb-0 text-muted font-weight-bold" style="font-size: 12px; ">IVR Recording</label>
                      <span class="text-muted small">Total Duration: {{ formatDuration(audioDuration ||
                        singleLead?.duration) }}</span>
                    </div>

                    <!-- Custom IVR Audio Player Container -->
                    <div class="custom-audio-player d-flex align-items-center">
                      <button type="button" class="audio-control-btn play-pause-btn"
                        (click)="togglePlayPause(ivrAudioPlayer)" [title]="isPlayingAudio ? 'Pause' : 'Play'">
                        @if (isPlayingAudio) {
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <rect x="6" y="4" width="4" height="16" rx="1"></rect>
                          <rect x="14" y="4" width="4" height="16" rx="1"></rect>
                        </svg>
                        } @else {
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z"></path>
                        </svg>
                        }
                      </button>

                      <!-- Speed Pill Button RIGHT NEXT to Play button -->
                      <button type="button" class="audio-speed-pill-btn" (click)="toggleAudioSpeed(ivrAudioPlayer)"
                        title="Click to cycle speed: 1x -> 1.5x -> 2x -> 3x">
                        {{ selectedAudioSpeed }}x
                      </button>

                      <!-- Time display -->
                      <span class="audio-time-text ml-2 mr-2">
                        {{ formatTime(currentAudioTime) }} / {{ formatTime(audioDuration || singleLead?.duration) }}
                      </span>

                      <!-- Seek slider -->
                      <div class="audio-progress-container flex-grow-1 mx-2">
                        <input type="range" class="audio-progress-slider" [min]="0"
                          [max]="audioDuration || singleLead?.duration || 100" [value]="currentAudioTime"
                          (input)="onAudioSeekInput($event)" (change)="onAudioSeekChange($event, ivrAudioPlayer)" />
                      </div>

                      <!-- Mute toggle button -->
                      <button type="button" class="audio-control-btn mute-btn" (click)="toggleMute(ivrAudioPlayer)"
                        [title]="isAudioMuted ? 'Unmute' : 'Mute'">
                        @if (isAudioMuted) {
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                          <line x1="23" y1="9" x2="17" y2="15"></line>
                          <line x1="17" y1="9" x2="23" y2="15"></line>
                        </svg>
                        } @else {
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                          <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                        </svg>
                        }
                      </button>

                      <audio #ivrAudioPlayer id="ivrRecording" [src]="singleLead?.extractedRecordingUrl"
                        preload="metadata" style="display: none;" (timeupdate)="onAudioTimeUpdate(ivrAudioPlayer)"
                        (play)="onAudioPlay($event)" (pause)="isPlayingAudio = false"
                        (ended)="isPlayingAudio = false; currentAudioTime = 0" (loadedmetadata)="onAudioLoaded($event)">
                      </audio>
                    </div>
                  </div>
                  } @else if (isIvrLead(singleLead)) {
                  <div class="pt-3 border-top mt-2" style="width: 100%;">
                    <div class="d-flex align-items-center justify-content-between mb-1">
                      <label class="mb-0 text-muted font-weight-bold" style="font-size: 12px;">IVR Recording</label>
                      @if (singleLead?.duration) {
                      <span class="text-muted small">Total Duration: {{ formatDuration(singleLead?.duration) }}</span>
                      }
                    </div>
                    <p class="text-muted mb-0 small" style="font-size: 12.5px;">
                      <i class="fas fa-exclamation-circle mr-1 text-warning"></i>
                      No recording available for this call.
                    </p>
                  </div>
                  }
                </div>
              </div>

            </div>

            <!-- BOTTOM CARD: Notes -->
            <div class="modal-section-card notes-card">
              <div class="section-card-header">
                <div class="section-card-header-left">
                  <div class="section-card-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                    </svg>
                  </div>
                  <h6 class="section-card-title">Notes</h6>
                </div>
              </div>

              <div class="notes-textarea-container">
                <textarea [(ngModel)]="statusnote" name="note" class="redesigned-notes-textarea"
                  placeholder="Write your note here..." maxlength="1000"></textarea>
                <span class="notes-char-counter">{{ (statusnote?.length || 0) }}/1000</span>
              </div>

              <!-- FOOTER ACTIONS -->
              <div class="modal-footer-actions">
                @if (!isUnQualifiedFilter) {
                @if (canDeleteLeads) {
                <button type="button" class="btn btn-delete-red-outline" data-dismiss="modal"
                  (click)="deleteLead(singleLead._id, singleLead)">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                  <span>Delete</span>
                </button>
                }

                @if (shouldShowUnassignButton) {
                <button type="button" class="btn btn-delete-red-outline"
                  style="border-color: #cbd5e1; color: #475569; background: #fff;" (click)="unassignLead(singleLead)">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="8.5" cy="7" r="4"></circle>
                    <line x1="18" y1="8" x2="23" y2="13"></line>
                  </svg>
                  <span>Unassign</span>
                </button>

                @if (shouldShowUpdateButton) {
                <button type="button" class="btn btn-assign-blue-solid" data-dismiss="modal"
                  (click)="updateLeadBadgeAndNotes()">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                    <polyline points="17 21 17 13 7 13 7 21"></polyline>
                    <polyline points="7 3 7 8 15 8"></polyline>
                  </svg>
                  <span>Update</span>
                </button>
                }
                } @else if (userDepartment !== 'MARKETING' || canAssignLeads) {
                <button type="button" class="btn btn-assign-blue-solid" data-dismiss="modal"
                  (click)="updateStatus(singleLead._id)">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="8.5" cy="7" r="4"></circle>
                    <line x1="20" y1="8" x2="20" y2="14"></line>
                    <line x1="23" y1="11" x2="17" y2="11"></line>
                  </svg>
                  <span>Assign</span>
                </button>
                }
                }
              </div>

            </div>

          </div>

        </div>
      </div>

    </div>
  </div>
</div>

<!-- CREATE OUTBOUND LEAD MODAL OVERLAY -->
@if (showCreateOutboundModal) {
<div class="outbound-modal-overlay d-flex align-items-center justify-content-center">
  <div class="outbound-modal-card" (click)="$event.stopPropagation()">
    <!-- MODAL HEADER -->
    <div class="outbound-modal-header d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center" style="gap: 12px;">
        <div class="outbound-modal-icon-badge">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="8.5" cy="7" r="4"></circle>
            <line x1="20" y1="8" x2="20" y2="14"></line>
            <line x1="17" y1="11" x2="23" y2="11"></line>
          </svg>
        </div>
        <div>
          <h5 class="mb-0 " style="font-size: 18px; color: #0f172a;">{{ isEditOutboundMode ? 'Edit Lead' : 'Create Lead'
            }}</h5>
          <span class="text-muted small">{{ isEditOutboundMode ? 'Update details of the outbound lead' : 'Enter details
            to create a new lead' }}</span>
        </div>
      </div>
      <button type="button" class="btn-close-sq" (click)="closeCreateOutboundLeadModal()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="outbound-modal-divider"></div>

    <!-- MODAL BODY FORM -->
    <div class="outbound-modal-body">
      @if (outboundErrorMessage) {
      <div class="outbound-alert-banner warning d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center" style="gap: 10px;">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <span>{{ outboundErrorMessage }}</span>
        </div>
        <button type="button" class="btn-close-alert" (click)="outboundErrorMessage = ''">&times;</button>
      </div>
      }

      <div class="outbound-form-grid">
        <!-- Name -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Name <span class="text-danger">*</span></label>
          <input type="text" name="name" class="custom-input"
            [class.is-invalid]="outboundErrorMessage && !outboundForm.name?.trim()" placeholder="Enter name"
            [(ngModel)]="outboundForm.name"
            (input)="outboundForm.name = $any($event.target).value; outboundErrorMessage = ''" />
        </div>

        <!-- Email -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Email</label>
          <input type="email" name="email" class="custom-input" placeholder="Enter email"
            [(ngModel)]="outboundForm.email" (input)="outboundForm.email = $any($event.target).value" />
        </div>

        <!-- Company Name -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Company Name</label>
          <input type="text" name="companyName" class="custom-input" placeholder="Enter company name"
            [(ngModel)]="outboundForm.companyName" (input)="outboundForm.companyName = $any($event.target).value" />
        </div>

        <!-- Designation -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Designation</label>
          <input type="text" name="designation" class="custom-input" placeholder="Enter designation"
            [(ngModel)]="outboundForm.designation" (input)="outboundForm.designation = $any($event.target).value" />
        </div>

        <!-- Phone Number -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Phone Number</label>
          <input type="tel" name="phoneNo" class="custom-input" placeholder="Enter phone number"
            [(ngModel)]="outboundForm.phoneNo" (input)="outboundForm.phoneNo = $any($event.target).value" />
        </div>

        <!-- Source -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Source</label>
          <input type="text" name="source" class="custom-input" value="Outbound" readonly disabled
            [(ngModel)]="outboundForm.source" />
        </div>

        <!-- Message -->
        <div class="outbound-field-group outbound-field-full">
          <label class="outbound-field-label">Message</label>
          <textarea name="message" class="custom-textarea" rows="3" placeholder="Enter message..."
            [(ngModel)]="outboundForm.message" (input)="outboundForm.message = $any($event.target).value"></textarea>
        </div>
      </div>
    </div>

    <!-- MODAL FOOTER -->
    <div class="outbound-modal-footer">
      <button type="button" class="gradient-btn" [disabled]="isSubmittingOutbound" (click)="submitCreateOutboundLead()">
        @if (isSubmittingOutbound) {
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span>{{ isEditOutboundMode ? 'Updating...' : 'Submitting...' }}</span>
        } @else {
        <span>{{ isEditOutboundMode ? 'Update' : 'Submit' }}</span>
        }
      </button>
    </div>
  </div>
</div>
}

<!-- USER ALERT MODAL OVERLAY -->
@if (userAlertModal.show) {
<div class="user-alert-overlay d-flex align-items-center justify-content-center" (click)="closeAlertModal()">
  <div class="user-alert-card" (click)="$event.stopPropagation()">
    <div class="user-alert-icon" [class.warning]="userAlertModal.type === 'warning'"
      [class.error]="userAlertModal.type === 'error'" [class.success]="userAlertModal.type === 'success'">
      @if (userAlertModal.type === 'warning' || userAlertModal.type === 'error') {
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
      } @else {
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
      }
    </div>
    <h4 class="user-alert-title">{{ userAlertModal.title }}</h4>
    <p class="user-alert-message">{{ userAlertModal.message }}</p>
    <div class="user-alert-footer">
      <button type="button" class="btn-alert-ok" (click)="closeAlertModal()">OK</button>
    </div>
  </div>
</div>
}